/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, Suspense, useCallback, useEffect, useState } from "react";
import {
  Dialog as DialogComponent,
  DialogActionsBar,
  DialogCloseEvent,
} from "@progress/kendo-react-dialogs";
import { Input, InputChangeEvent } from "@progress/kendo-react-inputs";
import {
  formatData,
  getFolderTree,
  getName,
  searchTreeItem,
  removeDataItemandStaticFolder,
  collectcustomfolderfromstatic,
  foldersstructure,
  convertDateFormat,
  convertExtensionToIcon,
} from "../helpers/helperMethods";
///import KendoDatepicker from "./KendoDatepicker";
import { DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';

import { ContextMenuEvent, DataModel } from "../interfaces/FileManagerModels";
import { TreeViewItemClickEvent } from "@progress/kendo-react-treeview";
import { useLayoutEffect } from "react";
//import SelectBox from "./SelectBox";
import {
  Servicecalls,
  Getteamusersfromsession,
  Silentauditobject,
  valiadateTenantPackage,
  setDateAsuserDefined,
  onGetUserControlRightsFolderstructure
} from "./../custom_functions/Functions.jsx";
import { isMultitenant } from "../custom_functions/Constance";
import { useInternationalization } from "@progress/kendo-react-intl";
//import { withAlert } from "react-alert";
//import { withTranslation } from "react-multi-lang";
import store from "./../redux_store/store/index";
import { MyGlobalContext } from "../custom_modules/orders/Sheetorder";
import { GlobalContext } from "../custom_modules/orders/Protocolroderstructure";
import { Modal, ModalBody } from "reactstrap";
import {
  //Dashboard,
  MyDashboardContext,
} from "../custom_modules/Dashboard";
import $, { event } from "jquery";
import { Button } from "reactstrap";
import { Progress } from "reactstrap";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { Row } from "reactstrap";
import { Col } from "reactstrap";
import { debounce } from 'lodash';
import { ProjectTeam } from "./ProjectTeamComponent";
import { confirmAlert } from "react-confirm-alert";

//import { Tree } from "rsuite";
//import { Item } from "react-horizontal-scrolling-menu/dist/types";

// import { FolderTree } from "./FolderTree";
const FolderTree = React.lazy(() =>
  import("./FolderTree").then(({ FolderTree }) => ({ default: FolderTree }))
);
const TextBox = React.lazy(() => import("./TextBox"));
const KendoDateTimepicker = React.lazy(() => import("./../controls/KendoDateTimepicker.jsx"));
const ELNurl = (window as any).appUrl.ELN;
const KendoCombobox = React.lazy(() => import("./KendoCombobox.jsx"));



export const EditDialog = (props: any) => {
  const [inputValue, setInputValue] = React.useState(props.editValue);
  const [inpuvaluescopy, setinpuvaluescopy] = useState(props.screen === "Reportdesigner" ? getName(inputValue.path)?.split('.')[0] : getName(inputValue.path));
  //const onAuditValidateError = (response: any) => { };

  //const onAuditValidateFailure = (response: any) => { };

  useLayoutEffect(() => {
    $(".dialogue-inner-panel .k-overlay").click((event) => {
      props.onDialogClose(event);
    });
  }, [props]);

  const handleDialogClick = (event: any) => {
    let renameClick = typeof inputValue === "string" ? inputValue : inputValue.path !== undefined ? inputValue.path : undefined // inputValue.path === undefined ? inputValue : undefined;

    if (
      (renameClick !== undefined &&
        renameClick.trim() === "" &&
        event.target.value === "rename") || (renameClick.endsWith('/') || renameClick.split('/').pop() === '')
    ) {
      props.alert.error(props.t("Orders.Sheetorders.IDS_LBL_FOLDERNAMEEMPTY"));
    } else {
      props.onDialogClick({
        event,
        path: props.editValue.path,
        value: typeof inputValue === "string" ? inputValue : inputValue.path.split('/').pop(),
        type: event.target.value,
      });
    }
  };

  const handleDialogClose = (event: DialogCloseEvent) => {
    props.onDialogClose(event);
  };

  const handleInputChange = (event: InputChangeEvent) => {
    const invalidCharsRegex = /[\/\\:.*?"<>|]/;
    const { value } = event;
    const { path } = inputValue;
    if (!invalidCharsRegex.test(value)) {
      let updatedPath = path.endsWith('/')
        ? path + value
        : path.replace(/[^\/]+$/, value);
      setInputValue({ ...inputValue, path: updatedPath });
      setinpuvaluescopy(value);
    } else {
      props.alert.error(
        props.t("A file name can't contain any of the following: \\:/.*?\"<>|")
      );
    }
  };

  // const handleInputChange = (event: InputChangeEvent) => {
  //   setInputValue(event.value);
  // };

  return (
    <DialogComponent
      className="dialogue-inner-panel- text-center"
      title={props.t("Orders.Sheetorders.IDS_LBL_CONFIRM")}
      onClose={handleDialogClose}
    >
      <p>
        <label className="required">
          {props.t(props.screen === "Reportdesigner" && props.editValue?.file !== undefined ? "Orders.Sheetorders.IDS_LBL_RENAMEREPORTFILE" : "Orders.Sheetorders.IDS_LBL_RENAMEFILE")},
        </label>
      </p>
      <Input
        maxLength={40}
        value={props.screen === "Reportdesigner" ? getName(inputValue.path)?.split('.')[0] : getName(inputValue.path)}
        style={{ maxWidth: "350px", textAlign: "center", width: "100%" }}
        className={"k-textbox"}
        onChange={handleInputChange}
        id="rename_inputbox"
      />
      <DialogActionsBar>
        <button
          id="id-dialog-rename"
          value={props.screen === "Reportdesigner" && props.editValue?.file !== undefined ? "Rename_File" : "rename"}
          className="k-button k-state-selected btn btn-primary-blue mr-2 my-2"
          onClick={handleDialogClick}
        >
          {props.t("Orders.Sheetorders.IDS_LBL_RENAME")}
        </button>
        <button
          id="id-dialog-closemodel"
          value={"cancel rename"}
          className="k-button btn_white_bg mr-2"
          onClick={handleDialogClick}
        >
          {props.t("Orders.Sheetorders.IDS_LBL_CANCEL")}
        </button>
      </DialogActionsBar>
    </DialogComponent>
  );
};

export const AddDialog = (props: any) => {
  const [inputValue, setInputValue] = React.useState("");
  const [KeywordValue, setKeywordValue] = useState("");
  const [radiobtnenable, setRadiobtnenable] = React.useState<number>(
    props.selectedFolder !== undefined &&
      props.selectedFolder.viewoption !== undefined
      ? props.selectedFolder.viewoption
      : 1
  );
  const [radioCDFbtnenable, setradioCDFbtnenable] = React.useState<number>(
    props.props?.onCDFselectstate
  );
  const [FOlder_Type, setFOlder_Type] = useState<any>({});
  const [Onselected_Foldertype, setOnselected_Foldertype] = useState<any>({});
  const [Projects, setProjects] = useState<any[]>([]);
  const [Material, setMaterial] = useState<any[]>([]);
  const [Tesk_Data, setTesk_Data] = useState<any[]>([]);
  const [Foldertype_Data, setFoldertype_Data] = useState<any[]>([{ code: 0, Folder_Type: props.t("Dashboard.IDS_LBL_GENERAL") }, { code: 1, Folder_Type: props.t("Dashboard.IDS_LBL_PROJECT") }, { code: 2, Folder_Type: props.t("Dashboard.IDS_LBL_TESTCODE") }, { code: 3, Folder_Type: props.t("Masters.Inventory.IDS_LBL_MATERIAL") }]);
  // const [Suggestion, setSuggestion] = React.useState<any[]>([]);
  // const [Enable_Suggestion, setEnable_Suggestion] = useState<boolean>(false);
  // const [userteamitems, setUserteamitems] = React.useState([]);
  // const [selectuserteam, setSelectuserteam] = React.useState(undefined);

  //const onAuditValidateError = (response: any) => { };

  //const onAuditValidateFailure = (response: any) => { };
  // const currentDate = sessionStorage.getItem("currentDate");
  // const intl = useInternationalization();
  // const stateCDFData = props.props.stateCDFData
  // stateCDFData.unshift({
  //     expanded:true,
  //     directorycode: null,
  //     parentdircode: -1,
  //     dateCreated: convertDateFormat(new Date(currentDate !== undefined && currentDate !== null ? currentDate : new Date()), intl),
  //     dateModified: convertDateFormat(new Date(), intl),
  //     size: 124,
  //     path: "Home",
  //     directoryname: props.t("Home"),
  //     icon: convertExtensionToIcon("Project", null),
  //     filefor: "HF",
  //     items: [],//projectitems,
  //   });
  const [controlRights] = React.useState(onGetUserControlRightsFolderstructure(props.props.screen));

  let pathvalue = props.props?.selectedCDPFolder?.filefor ? props.props?.selectedCDPFolder?.path : "";
  pathvalue = pathvalue.replace(/\//g, " -> ");

  let pathfvalue = props.props?.selectedFolder?.filefor ? props.props?.selectedFolder?.path : "";
  pathfvalue = pathfvalue.replace(/\//g, " -> ");

  useLayoutEffect(() => {
    if (props.selectedFolder !== undefined && props.selectedFolder.viewoption === 3) {
      let usermasterobj = JSON.parse(sessionStorage.teamusercode);
      if (usermasterobj.length > 0) {
        setRadiobtnenable(3);
      } else {
        props.alert.error(props.t("Orders.Sheetorders.IDS_LBL_NOTMAPPEDPROJECTTEAM", { showitem: "to me", }));
      }
    }

    $(".dialogue-inner-panel .k-overlay").click((event) => {
      props.onDialogClose(event);
    });
  }, [props]);

  useEffect(() => {

    let passObjDet = store.getState().Loggeduser !== undefined && store.getState().Loggeduser !== null && Object.keys(store.getState().Loggeduser).length > 0 ? store.getState().Loggeduser
      : {
        usercode: sessionStorage.User,
        username: sessionStorage.Username,
        lssitemaster: { sitecode: sessionStorage.Usersite },
      };

    Servicecalls("" + ELNurl + "/File/Gettaskforordercreate",
      passObjDet, (res: any) => { setTesk_Data(res); }, () => { });
    Servicecalls("" + ELNurl + "/File/Getprojectforordercreate",
      passObjDet, (res: any) => { setProjects(res); }, () => { });
    Servicecalls("" + ELNurl + "/File/Getmaterialforordercreate",
      passObjDet, (res: any) => { setMaterial(res); }, () => { });

    setFOlder_Type(Foldertype_Data[0])

    if (props.EnableAddDialog !== undefined) {
      document.body.classList.add('Add-Newfolder');
    }
    return () => {
      document.body.classList.remove('Add-Newfolder');
    };
  }, []);

  useEffect(() => {

    console.log("kumu")
    if (props?.ReportScreen !== undefined && props?.ReportScreen && props?.TemplateName !== undefined) {
      setInputValue(props.TemplateName);
    }

    if (props?.ReportScreen !== undefined && props?.ReportScreen && props?.TemplateKeyword !== undefined && props?.TemplateKeyword !== "") {
      setKeywordValue(props?.TemplateKeyword);
    }
  }, [props]);

  const handleDialogClick = (event: any) => {
    if (inputValue.trim() === "" && (event.target.value === "add" || event.target.value === "save")) {
      props.alert.error(props.t("Orders.Sheetorders.IDS_LBL_FOLDERNAMEEMPTY"));
    } else {
      let Enable_Newfolder: any = props?.Enable_Newfolder !== undefined ? props.Enable_Newfolder : undefined;
      props.onDialogClick({
        event,
        path: inputValue,
        value: inputValue,
        type: event.target.value,
        folderplace: radiobtnenable,
        selectedCDF: radioCDFbtnenable,
        FOlder_Type: FOlder_Type, Onselected_Foldertype: Onselected_Foldertype, Enable_Newfolder: Enable_Newfolder, ReportTemplateKeyword: KeywordValue
      });
    }
  };

  const handleDialogClose = (event: DialogCloseEvent) => {
    props.onDialogClose(event);
    // let passObjDet = {
    //   objsilentaudit: Silentauditobject(
    //     "close",
    //     "Register Orders",
    //     props.t("FOLDER.IDS_REQCLOSENEWFOLDER", {
    //       user: props.sessionvalues.username,
    //     })
    //   ),
    // };
    // Servicecalls(
    //   "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
    //   passObjDet,
    //   onAuditValidateError.bind(this),
    //   onAuditValidateFailure.bind(this)
    // );
  };

  // const fetchSearchResults = async (inputValue: any) => {
  //   let passObjDet = {
  //     Searchkey: inputValue,
  //     sitecode: Number(sessionStorage.Usersite)
  //   };

  //   console.log({ "300 Time delay": inputValue });
  //   Servicecalls(
  //     "" + ELNurl + "/Instrument/Suggesionforfolder",
  //     passObjDet,
  //     OngetSuggestionsuccessevent,
  //     () => { }
  //   );
  // };

  // const OngetSuggestionsuccessevent = (Response: any) => {
  //   Response = Response.map((items: any) => {
  //     items.sourceTable = items.sourceTable === "lsprojectmaster" ? "ProjectMaster" : items.sourceTable === "lstestmasterlocal" ? "Testmaster" : "Materiail";
  //     return items;
  //   })
  //   setSuggestion(Response);
  // }


  // const debouncedFetchSearchResults = useCallback(
  //   debounce((inputValue) => {
  //     fetchSearchResults(inputValue);
  //   }, 300),
  //   []
  // );


  // useEffect(() => {
  //   if (inputValue && Enable_Suggestion) {
  //     debouncedFetchSearchResults(inputValue);
  //   } else {
  //     setSuggestion([]);
  //   }
  // }, [inputValue, debouncedFetchSearchResults, Enable_Suggestion]);

  const handleInputChange = (event: InputChangeEvent) => {
    const charsRegex = /[\/\\:.*?"<>|]/;

    if (!charsRegex.test(event.value)) {
      // setEnable_Suggestion(true);
      setInputValue(event.value);
    } else {
      props.alert.error(
        props.t("A file name can't contain any of the following: \\:/.*?\"<>|")
      );
    }
  };
  const handleInputChangeOnReportTemplate = (event: InputChangeEvent) => {
    const charsRegex = /[\/\\:.*?"<>|]/;

    if (!charsRegex.test(event.value)) {
      // setEnable_Suggestion(true);
      setInputValue(event.value);
      debouncedFetchSearchResults(event.value);
    } else {
      props.alert.error(
        props.t("A file name can't contain any of the following: \\:/.*?\"<>|")
      );
    }
  };

  const onKeywordChange = (event: InputChangeEvent) => {
    setKeywordValue(event.value)
    debouncedFetchSearchResultsonkeyword(event.value);
  }


  const debouncedFetchSearchResults = useCallback(debounce((values) => {
    if (props.TemplateNameOnchange !== undefined) {
      props.TemplateNameOnchange(values);

    }
  }, 100), []);
  const debouncedFetchSearchResultsonkeyword = useCallback(debounce((values) => {
    if (props.TemplatekeywordOnchange !== undefined) {
      props.TemplatekeywordOnchange(values);
    }
  }, 100), []);

  const onradiobtnclick = (event: any) => {
    const selectedFolder = radioCDFbtnenable === 4 ? props.selectedFolder : props.props?.selectedCDPFolder;
    const isProjectmappedfolder = FOlder_Type?.code === 1 ? true : false;

    if (isProjectmappedfolder && parseInt(event.target.value) === 1) {
      props.alert.error(
        props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWSITEVAL", {
          showitem: "to Team",
        })
      );
    }
    else if (
      selectedFolder !== undefined &&
      (selectedFolder.viewoption === 3) &&
      parseInt(event.target.value) !== 3 &&
      parseInt(event.target.value) !== 2
    ) {
      props.alert.error(
        props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWSITEVAL", {
          showitem: "to Team",
        })
      );
    } else if (
      selectedFolder !== undefined &&
      selectedFolder.viewoption === 2 &&
      parseInt(event.target.value) !== 2
    ) {
      props.alert.error(
        props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWOPTION", {
          showitem: "to me",
        })
      );
    } else if (parseInt(event.target.value) === 3) {
      let usermasterobj = JSON.parse(sessionStorage.teamusercode);
      if (usermasterobj.length > 0) {
        setRadiobtnenable(parseInt(event.target.value));
      } else {
        props.alert.error(
          props.t("Orders.Sheetorders.IDS_LBL_NOTMAPPEDPROJECTTEAM", {
            showitem: "to me",
          })
        );
      }
    } else {
      setRadiobtnenable(parseInt(event.target.value));
    }
  };
  const onradioCDFbtnonClick = (event: any) => {
    let value = props.props?.onradioCDFbtnonClick(event);
    if (value === 4) {
      setradioCDFbtnenable(value);
    } else if (value === 5) {
      setradioCDFbtnenable(value);
    }
  };


  const flattenHierarchy = (stateDataobj: any) => {
    return stateDataobj?.reduce((result: any[], currentValue: any) => {
      result.push(currentValue);
      if (currentValue.items) {
        result = result.concat(flattenHierarchy(currentValue.items));
      }
      return result;
    }, []);
  }

  // const onSuggestionClick = (item: any) => {
  //   if (item?.name) {
  //     try {
  //       const folders = flattenHierarchy(props?.folderdata);
  //       const isSameFolder = folders.some((folder: any) => folder.filefor === 'DR' && folder.directoryname?.trim() === item.name.trim());
  //       if (!isSameFolder) {
  //         setInputValue(item.name || "");
  //         setEnable_Suggestion(false);
  //         setSuggestion([]);
  //         console.log("kumu");
  //       } else {
  //         props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_FOLDEREXIST"));
  //         setInputValue("");
  //         setEnable_Suggestion(false);
  //         setSuggestion([]);
  //       }
  //     } catch (error) {
  //       console.error("Error processing folder data:", error);
  //     }
  //   }
  // };





  // const onSuggestionrender = () => {
  //   return (
  //     Suggestion.map((items: any, index: number) => {
  //       return (
  //         <li key={items.projectname + "_" + index.toString()} onClick={() => { onSuggestionClick(items) }}>
  //           <span className="list-icon-view">
  //             <span >
  //               <span className="search-text"> {`${items.name} - ${items.sourceTable}`}</span>
  //             </span>
  //           </span>
  //         </li>
  //       );
  //     })
  //   );
  // };

  //const onGetProjectTeamFailure = (response: any) => { }

  return (
    <>
      {/* <DialogComponent
          className="dialogue-inner-panel form-group fixed-dashboard"
          title={props.t("Orders.Sheetorders.IDS_LBL_CREATENEWFOLDER")}
          onClose={handleDialogClose}
        > */}
      {/* <div className="filter-dropdown w-100">
        <div className="input-auto-suggestion" >
          <div className="form-group">
            <label className="required">
              {props.t("Orders.Sheetorders.IDS_LBL_NEWFILE")}
            </label>
            <Input
              maxLength={40}
              value={inputValue}
              className={"k-textbox input-pad form-control"}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="suggest_typed shadow-outlet-black">
          {Suggestion.length > 0 &&

            <React.Fragment>
              <OverlayScrollbarsComponent style={{ maxHeight: "180px" }}
                options={{
                }}
              >
                <ul key={"filtermenu"}>
                  {onSuggestionrender()}
                </ul>

              </OverlayScrollbarsComponent>
              <div className="Footer_Globalsearch">
                <p className="Total-Count">Total: {Suggestion.length}</p>
              </div>
            </React.Fragment>

          }
        </div>
      </div> */}

      {props.ReportScreen !== undefined && props.ReportScreen ?
        <>
          < div className="row clearfix" >
            <div className="equal-split-flex w-100 parent-padd-1">
              <div className="form-group">
                <label className="required">
                  {props.t("Orders.Sheetorders.IDS_REPORTNAME")}
                </label>
                <Input
                  maxLength={40}
                  value={inputValue}
                  className={"k-textbox input-pad form-control bottom-border"}
                  onChange={handleInputChangeOnReportTemplate}
                  style={{ width: '350px', marginLeft: "20px" }}
                />
              </div>

            </div>
          </div>
          < div className="row clearfix" >
            <div className="equal-split-flex w-100 parent-padd-1">
              <div className="form-group">
                <label className="mg-r-1 form-label">
                  {props.t("Orders.Sheetorders.IDS_LBL_KEYWORD")}
                </label>
                <Input
                  maxLength={40}
                  value={KeywordValue}
                  className={"k-textbox input-pad form-control"}
                  onChange={onKeywordChange}
                  style={{ width: '350px', marginLeft: "20px" }}
                />
              </div>

            </div>
          </div>
        </>
        :
        <>
          < div className="row clearfix" >
            <div className="equal-split-flex w-100 parent-padd-1">

              <div className="form-group" style={{ marginRight: "25px" }}>
                <label className="required">
                  {props.t("Orders.Sheetorders.IDS_LBL_NEWFILE")}
                </label>
                <Input
                  maxLength={40}
                  value={inputValue}
                  className={"k-textbox input-pad form-control bottom-border"}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group Folder_Type">
                <label className="required">
                  {props.t("Orders.Sheetorders.IDS_LBL_TYPE")}
                </label>
                <Suspense fallback={<div></div>}>
                  <KendoCombobox
                    initialValue=""
                    id="id-combo-sheetorder"
                    Datasource={Foldertype_Data}
                    DefaultValue={FOlder_Type}
                    onvaluechange={(object: any) => {
                      setFOlder_Type(object === null ? {} : object);
                      setOnselected_Foldertype({})
                      if (object?.code === 1) {
                        setRadiobtnenable(3);
                      }
                    }}
                    ValueMember="code"
                    DisplayMember="Folder_Type"
                    Placeholder={props.t("Orders.Sheetorders.IDS_LBL_TYPE")}

                  />
                </Suspense>
              </div>

              {/* <div className="form-group">
            <label className="required">
              {props.t("Orders.Sheetorders.IDS_LBL_NEWFILE")}
            </label>
            <Input
              maxLength={40}
              value={inputValue}
              className={"k-textbox input-pad form-control"}
              onChange={handleInputChange}
            />
          </div> */}


            </div>
          </div >
          {
            Object.keys(FOlder_Type).length > 0 && FOlder_Type?.code !== 0 && <div className="row clearfix">
              <div className="equal-split-flex w-100 parent-padd-1">
                <div className="form-group">
                  <Suspense fallback={<div></div>}>
                    <KendoCombobox
                      initialValue=""
                      id="id-combo-sheetorder"
                      Datasource={FOlder_Type?.code === 1 ? Projects : FOlder_Type?.code === 2 ? Tesk_Data : FOlder_Type?.code === 3 ? Material : []}
                      DefaultValue={Onselected_Foldertype}
                      onvaluechange={(object: any) => { setOnselected_Foldertype(object === null ? {} : object); }}
                      ValueMember={FOlder_Type?.code === 1 ? "projectcode" : FOlder_Type?.code === 2 ? "testcode" : FOlder_Type?.code === 3 ? "matcode" : "code"}
                      DisplayMember={FOlder_Type?.code === 1 ? "projectname" : FOlder_Type?.code === 2 ? "testname" : FOlder_Type?.code === 3 ? "matname" : "Folder_Type"}
                      Placeholder={FOlder_Type?.code === 1 ? props.t("Dashboard.IDS_LBL_PROJECT") : FOlder_Type?.code === 2 ? props.t("Dashboard.IDS_LBL_TESTCODE") : FOlder_Type?.code === 3 ? props.t("Masters.Inventory.IDS_LBL_MATERIAL") : props.t("Dashboard.IDS_LBL_GENERAL")}
                      className={"report-design-mat"}
                    />
                  </Suspense>
                </div>
              </div>
            </div>
          }
        </>
      }
      {/* {props.ReportScreen === undefined && */}
      {isMultitenant === 2 ? "" :
        < div className="row clearfix" >
          <div className="equal-split-flex w-100 parent-padd-1">
            <div className="form-group">
              <label className={"radio"}>
                <input
                  type="radio"
                  value="1"
                  name="Selectfolder"
                  onChange={onradiobtnclick}
                  checked={radiobtnenable === 1}
                // checked={isMoveParent === 1}
                // disabled={
                //   props.selectedFolder !== undefined && (props.selectedFolder.viewoption === 3 || props.selectedFolder.viewoption === 2)
                //     ? true
                //     : false
                // }
                />
                <span>{props.t("Orders.Sheetorders.IDS_LBL_SHOWTOSITE")}</span>
              </label>
            </div>
            {/* <div className="form-group">
              <label className={"radio"}>
                <input
                  type="radio"
                  value="2"
                  name="Selectfolder"
                  onChange={onradiobtnclick}
                  checked={radiobtnenable === 2}
                // disabled={
                //   props.selectedFolder !== undefined && (props.selectedFolder.viewoption === 3 || props.selectedFolder.viewoption === 2)
                //     ? true
                //     : false
                // }
                />
                <span>{props.t("Orders.Sheetorders.IDS_LBL_SHOWONLYTOME")}</span>
              </label>
            </div> */}
            {controlRights.projectteam && <div className="form-group">
              <label className={"radio"}>
                <input
                  type="radio"
                  value="3"
                  name="Selectfolder"
                  onChange={onradiobtnclick}
                  checked={radiobtnenable === 3}
                // disabled={
                //   props.selectedFolder !== undefined && props.selectedFolder.viewoption === 3
                //     ? true
                //     : false
                // }
                />
                <span>
                  {props.t("Orders.Sheetorders.IDS_LBL_SHOWONLYTOTEAM")}
                </span>
              </label>
            </div>}
          </div>
        </div >
      }
      {/* } */}


      {
        props.selectedFolder?.directoryname === "Reportdesigner" || props.selectedFolder?.directoryname === "Reportviewer" ? (
          ""
        ) : props.selectedFolder?.filefor !== "DR" ? (
          <div><label className="mb-2">{props.t("Orders.Sheetorders.IDS_LBL_CHOOSEFOLDERPATH", { param: "" })} </label>
            <div className="row k-filemanager-content-container folder-tree report-create-popup">

              <Suspense fallback={<div></div>}>
                <FolderTree
                  data={props.props?.stateCDFData}
                  selected={props.props?.selectedCDPFolder}
                  selectedItem={props.props?.selectedCDPFolder}
                  onItemClick={props.props?.onFolderCDPItemClick}
                  onContextMenu={props.props?.onContextMenu}
                  OnRightClick={true}
                />

              </Suspense>

            </div>
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className={"radio"}>
                    <input
                      type="radio"
                      id="4"
                      name="Current Path"
                      value="4"
                      checked={radioCDFbtnenable === 4}
                      onChange={onradioCDFbtnonClick}
                    />
                    <span>{props.t("Orders.Sheetorders.IDS_LBL_CURRENTPATH", { param: "" })}</span>
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className={"radio"}>
                    <input
                      type="radio"
                      id="5"
                      name="Custom Path"
                      value="5"
                      checked={radioCDFbtnenable === 5}
                      onChange={onradioCDFbtnonClick}
                    />
                    <span>{props.t("Orders.Sheetorders.IDS_LBL_CUSTOMPATH", { param: "" })}</span>
                  </label>
                </div>
              </div>
            </div>
            {radioCDFbtnenable === 5 && (
              <div className="row k-filemanager-content-container folder-tree">
                <Suspense fallback={<div></div>}>
                  <FolderTree
                    data={props.props?.stateCDFData}
                    selected={props.props?.selectedCDPFolder}
                    selectedItem={props.props?.selectedCDPFolder}
                    onItemClick={props.props?.onFolderCDPItemClick}
                    onContextMenu={props.props?.onContextMenu}
                    OnRightClick={true}
                  />
                </Suspense>
              </div>
            )}
          </>
        )
      }
      < br />
      {
        props.selectedFolder?.directoryname === "Reportdesigner" || props.selectedFolder?.directoryname === "Reportviewer" ? (
          ""
        ) : props.selectedFolder?.filefor !== "DR" ? (
          <>
            <br />
            <div className="form-group " style={{ textAlign: "justify" }}>
              <b>{props.t("Orders.Sheetorders.IDS_LBL_FPATH")} : </b>
              {pathvalue}
            </div>
            {/* <div className="form-group " style={{ textAlign: "justify" }}>
              <b>{props.t("Orders.Sheetorders.IDS_LBL_NOTE")} : </b>
              {props.t("Orders.Sheetorders.IDS_LBL_FOLDERNOTE")}
            </div> */}
          </>
        ) : (
          <>
            <div className="form-group " style={{ textAlign: "justify" }}>
              <b>{props.t("Orders.Sheetorders.IDS_LBL_FPATH")} : </b>
              {radioCDFbtnenable === 4 ? pathfvalue : pathvalue}
            </div>{" "}
            {/* {radioCDFbtnenable === 5 ? (
              <div className="form-group " style={{ textAlign: "justify" }}>
                <b>{props.t("Orders.Sheetorders.IDS_LBL_NOTE")} : </b>
                {props.t("Orders.Sheetorders.IDS_LBL_FOLDERNOTE")}
              </div>
            ) : (
              ""
            )} */}
          </>
        )
      }
      < DialogActionsBar >
        <div className="mg-t-half mg-b-half action-btn">

          {props.ReportScreen !== undefined && props.ReportScreen ?
            <>
              {controlRights.newFolder && <Button className="btn btn-primary-blue mg-l-1 mg-r-half" onClick={() => { props.InsideNewFolderHandle(true) }} >
                <i className="fa-solid fa fa-folder-plus" />
                <span>
                  {props.t("Orders.Sheetorders.IDS_LBL_NEWFOLDER", { param: "", })}
                </span>
              </Button>}
              <Button
                id="id-dialog-add"
                value={props.isEditMode ? "add" : 'addReport'}
                className="btn btn-primary-blue mg-r-half mb-0"
                onClick={handleDialogClick}
                disabled={radioCDFbtnenable === 4 && props.props?.selectedCDPFolder?.filefor === "DR" ? false : true}
              >
                {props.isSaveAs_Enable !== undefined && props.isSaveAs_Enable ? props.t("Templates.Sheettemplates.IDS_LBL_SAVEAS") : props.t("Dashboard.IDS_LBL_SAVE")}
              </Button>
            </>
            :
            <button
              id="id-dialog-add"
              value={"save"}
              disabled={
                props.props?.selectedCDPFolder?.filefor === "HF" ||
                  props.props?.selectedCDPFolder?.filefor === "TMM" ||
                  props.props?.selectedCDPFolder?.filefor === "TMP" ||
                  props.props?.selectedCDPFolder?.filefor === "DR" ||
                  (radioCDFbtnenable === 4 &&
                    props.props?.selectedFolder?.filefor === "DR")
                  ? false
                  : true
              }
              className="btn btn-primary-blue mg-r-half"
              onClick={handleDialogClick}
            >
              {props.t("Orders.Sheetorders.IDS_LBL_ADD")}
            </button>

          }

          <button
            id="id-dialog-canceldelete"
            value={"cancel add"}
            className="btn_white_bg icon-lg mg-r-1 button"
            onClick={handleDialogClick}
          >
            {props.t("Orders.Sheetorders.IDS_LBL_CANCEL")}
          </button>
        </div>
      </DialogActionsBar >
    </>
    // </DialogComponent>
  );
};

export const CreateDialog = (props: any) => {
  // const stateData = removeDataItem(props.folderdata, props.userData != null ? props.userData : { path: "-" });

  // console.log(stateData);
  const isPremiumTenant = valiadateTenantPackage() === "3" ? true : false;
  const user = useContext(MyGlobalContext);
  const dashboard = useContext(MyDashboardContext);
  const protocol = useContext(GlobalContext);
  const [Enable_Newfolder, setEnable_Newfolder] = useState<boolean>(false);
  console.log(user);
  const intl = useInternationalization();
  const [stateData, setStateData] = React.useState<DataModel[]>(
    props.folderdata?.filter(
      (item: any) => item.filefor === "DR"
      // item.filefor === "PR" || item.filefor === "DR" || item.filefor === "SMM"
    )
    // formatData(
    //   removeDataItemandStaticFolder(
    //     props.folderdata,
    //     props.userData != null ? props.userData : { path: "-" }
    //   ),
    //   intl
    // )
  );
  const [testData, setTestData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [sheetData, setSheetData] = React.useState<any>(formatData([], intl));
  const [approveSheetData, setApproveSheetData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [users, setUsers] = React.useState<DataModel[]>(formatData([], intl));
  // const [isDueDateChecked, setIsDueDateChecked] = React.useState<any>(null);
  const [isDueDateChecked, setIsDueDateChecked] = useState(false);
  const [showTimePicker, setShowTimePicker] = React.useState(true);

  //const [isAutoRegister, setIsAutoRegister] = React.useState<Boolean>(false);
  const [isAutoRegister, setIsAutoRegister] = useState(false);
  // useState(false);

  // added for duedate

  const [screen] = React.useState<string>(props.screen);


  const [controlRights] = React.useState(onGetUserControlRightsFolderstructure(screen));

  useEffect(() => {
    setStateData(props.folderdata?.filter(
      (item: any) => item.filefor === "DR"
      // item.filefor === "PR" || item.filefor === "DR" || item.filefor === "SMM"
    ))

  }, [props.folderdata]);

  const userDefinedDate =
    sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" ||
      sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss" ||
      sessionStorage.userDefinedDate === "UTC Format"
      ? "YY/MM/DD HH:mm:ss"
      : sessionStorage.userDefinedDate;
  const currentDayuserdef = setDateAsuserDefined(new Date(), userDefinedDate);

  const [selectedprojectteam, setSelectedProjectTeam] = useState<any[]>([]);

  const [currentDayuserdefstate, setcurrentDayuserdefstate] = React.useState<any>();
  const [autoregisterdate, setautoregisterdate] = React.useState<any>();
  let periods: any = [];
  periods = [
    { type: 1, name: props.t("Orders.Sheetorders.IDS_LBL_HOURS") },
    { type: 2, name: props.t("Orders.Sheetorders.IDS_LBL_WEEKS") },
    { type: 3, name: props.t("Orders.Sheetorders.IDS_LBL_DAYS") },
    { type: 4, name: props.t("Orders.Sheetorders.IDS_LBL_MONTHS") },
    { type: 5, name: props.t("Orders.Sheetorders.IDS_LBL_YEARS") },
    // { type: 6, name: props.t("Orders.Sheetorders.IDS_LBL_MINUTES") },
  ];
  let Duration: any = [];
  Duration = [
    { type: 1, name: props.t("Orders.Sheetorders.IDS_LBL_HOURS") },
    { type: 3, name: props.t("Orders.Sheetorders.IDS_LBL_DAYS") },
    { type: 2, name: props.t("Orders.Sheetorders.IDS_LBL_WEEKS") },
    // { type: 4, name: props.t("Orders.Sheetorders.IDS_LBL_MINUTES") },
  ];
  const [Durationvalue, setDurationvalue] = React.useState<any>();
  const [Interval, setInterval] = React.useState<any>();
  const [Autoregister_Count, setAutoregister_Count] = useState<any>();
  const [periodsvalue, setperiodsvalue] = React.useState<any>();
  const [duedate, setduedate] = React.useState<any>();

  const [currentday, setcurrentday] = React.useState<any>(new Date());

  const currentTime = new Date();
  const currentHour = currentTime.getHours();
  const currentMinute = currentTime.getMinutes();
  const currentSecond = currentTime.getSeconds();

  const [SpellBefore, setSpellBefore] = React.useState<any>();
  const today = new Date(); const current = new Date();
  const datefilter = today.getDate() + 600;
  //const mindatefil=current.getDate()+1;
  const maxDate = new Date(today.setDate(datefilter));
  //const minDate=new Date(current.setDate(mindatefil));
  const minDate = current;
  // added for duedate
  const [projectData, setProjectData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [stateSampleData, setStateSampleData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [stateRepoData, setStateRepoData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [stateRepodataData, setStateRepodataData] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [stateMaterial, setStateMaterial] = React.useState<DataModel[]>(
    formatData([], intl)
  );
  const [stateMaterialInventory, setStateMaterialInventory] = React.useState<
    DataModel[]
  >(formatData([], intl));
  const [selectMaterial, setselectMaterial] = React.useState<any>();
  const [selectMaterialInventory, setselectMaterialInventory] =
    React.useState<any>();

  const [selectOrderData, setselectOrderData] = React.useState<any>({});
  const [selectTestData, setselectTestData] = React.useState<any>();
  const [selectSheetData, setselectSheetData] = React.useState<any>();
  const [selectProjectData, setselectProjectData] = React.useState<any>();
  const [selectSampleData, setselectSampleData] = React.useState<any>();
  const [selectRepoData, setselectRepoData] = React.useState<any>();
  const [selectRepodataData, setselectRepodataData] = React.useState<any>();
  const [selectWflowData, setselectWflowData] = React.useState<{
    usercode: any;
    username: any;
  }>();
  const [ProtocolItems, setProtocolItems] = React.useState<any>(
    formatData([], intl)
  );
  const [SelectedProtocol, setSelectedProtocol] = React.useState<any>();

  const [selectUser, setselectUser] = React.useState<{
    usercode: any;
    username: any;
  } | null>();
  const [selectOrderKey, setselectOrderKey] = React.useState<any>();
  const [selectOrdertittle, setSelectOrdertittle] = React.useState<any>();

  const [selectFolderData, setselectFolderData] =
    React.useState<DataModel | null>(null);
  const [isMoveParent, setIsMoveParent] = React.useState<number>(
    props.selectedFolder === undefined || props.selectedFolder === null
      ? 4
      : props.selectedFolder.filefor !== undefined &&
        props.selectedFolder.filefor !== "DR"
        ? 4
        : 3
  );

  const [Selected_Path, setSelected_Path] = useState<any>(props?.selectedFolder?.filefor === "DR" ? props?.selectedFolder?.path?.replace(/\//g, " -> ") || "" : "");
  // const [userteamitems, setUserteamitems] = React.useState([]);
  // const [selectuserteam, setSelectuserteam] = React.useState(undefined);

  const [isshowtosite, setIsshowtosite] = React.useState<number>(
    props.selectedFolder !== undefined &&
      props.selectedFolder.viewoption !== undefined
      ? props.selectedFolder.viewoption
      : 1
  );
  const [isStoreOnCurrent] = React.useState<Boolean>(
    props.selectedFolder === undefined || props.selectedFolder === null
      ? false
      : props.selectedFolder.filefor !== undefined &&
        props.selectedFolder.filefor !== "DR"
        ? false
        : true
  );
  const [selectedTreeItem, setSelectedTreeItem] =
    React.useState<DataModel | null>(props.selectedFolder);
  const [treeClicked, setTreeClicked] = React.useState<boolean>(false);
  const [flows, setFlows] = React.useState<any>([
    {
      usercode: -2,
      username: props.t("Orders.Protocolorders.IDS_LBL_NOWORKFLOW", {
        param: "",
      }),
    },
  ]);
  let splitBtnItems: any = [];
  splitBtnItems = [
    { type: 2, name: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_ELNTASKSWITHTEMPLATE") : props.t("Orders.Sheetorders.IDS_LBL_ELNORDER") },
    { type: 3, name: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_RESEARCHACTASKSWITHOUTTEMPLATE") : props.t("Orders.Sheetorders.IDS_LBL_RESEARCHORDER") },
    { type: 4, name: props.t("Orders.Sheetorders.IDS_LBL_EXCELMANAGEMENT", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASKS") : props.t("Dashboard.IDS_LBL_ORDERS") }) },
    { type: 5, name: props.t("Orders.Sheetorders.IDS_LBL_EVALUATION") },
  ];

  let val: any[] = [];
  if (screen === "Sheet" && user !== null) {
    splitBtnItems.map((item: any) => {
      if (user.ELNorder === true && item.type === 2) {
        val.push(item);
      } else if (user.Researchvisible === true && item.type === 3) {
        val.push(item);
      } else if (user.Excelsavevisb === true && item.type === 4) {
        val.push(item);
      } else if (user.Evalsavevisb === true && item.type === 5) {
        val.push(item);
      }
      return item;
    });
    splitBtnItems = val;
  } else if (
    screen === "Sheet" &&
    dashboard !== null &&
    dashboard !== undefined
  ) {
    splitBtnItems.map((item: any) => {
      if (dashboard.ELNorder === true && item.type === 2) {
        val.push(item);
      } else if (dashboard.Researchvisible === true && item.type === 3) {
        val.push(item);
      } else if (dashboard.Excelsavevisb === true && item.type === 4) {
        val.push(item);
      } else if (dashboard.Evalsavevisb === true && item.type === 5) {
        val.push(item);
      }
      return item;
    });
    splitBtnItems = val;
  }

  let splitprotocolorderitems: any = [];
  if (isMultitenant === 2) {
    splitprotocolorderitems = [
      {
        type: 1,
        name: props.t("Audittrail.Audittrailhistory.Screenname.IDS_LBL_PROTOCOLTASKSWITHTEMPLATE"),
      },
      {
        type: 2,
        name: props.t("Audittrail.Audittrailhistory.Screenname.IDS_LBL_PROTOCOLTASKSWITHOUTTEMPLATE"),
      },
    ];
  } else {
    splitprotocolorderitems = [
      {
        type: 1,
        name: props.t("Orders.Protocolorders.IDS_LBL_ELNPROTO", { screenname: isMultitenant === 2 ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER") }),
      },
      {
        type: 2,
        name: props.t("Orders.Protocolorders.IDS_LBL_DYNAMICPROTO", { screenname: isMultitenant === 2 ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER") }),
      },
    ];
  }

  let value: any[] = [];
  if (screen === "Protocol" && protocol !== null) {
    splitprotocolorderitems.map((item: any) => {
      if (protocol.elnordersave === true && item.type === 1) {
        value.push(item);
      } else if (protocol.dynordersave === true && item.type === 2) {
        value.push(item);
      }
      return item;
    });
    splitprotocolorderitems = value;
  } else if (
    screen === "Protocol" &&
    dashboard !== null &&
    dashboard !== undefined
  ) {
    splitprotocolorderitems.map((item: any) => {
      if (dashboard.elnordersave && item.type === 1) {
        value.push(item);
      } else if (dashboard.dynordersave && item.type === 2) {
        value.push(item);
      }
      return item;
    });
    splitprotocolorderitems = value;
  }
  const [selectprotocolOrderData, setsselectprotocolOrderData] =
    React.useState<any>({});

  //const onAuditValidateError = (response: any) => { };

  //const onAuditValidateFailure = (response: any) => { };

  const getdirectory = (isassigneduser: any, selecteduser: any) => {
    let passObjDet = selecteduser;
    passObjDet.reset = true;
    passObjDet.activeusersite = { sitecode: Number(sessionStorage?.Usersite) }
    Servicecalls("" + ELNurl + "/Instrument/Getfoldersfordashboard", passObjDet, onGetfoldersfordashboardSuccess, ongetmasterfailure);
  };

  const onGetfoldersfordashboardSuccess = (responce: any) => {

    responce.directory = responce?.directory?.filter((x: any) => {
      return x?.sitemaster?.sitecode === Number(sessionStorage?.Usersite)
    });

    responce.directorypro = responce?.directorypro?.filter((x: any) => {
      return x?.sitemaster?.sitecode === Number(sessionStorage?.Usersite)
    });

    let folderdatatemp = foldersstructure(
      screen === "Sheet" ? responce.directory : responce.directorypro,
      screen === "Sheet" ? 1 : 2, intl
    );
    setStateData(folderdatatemp);
  };

  useLayoutEffect(() => {


    const newSelectedItem: DataModel = searchTreeItem(
      stateData,
      props.selectedFolder
    );

    if (newSelectedItem !== undefined) {
      newSelectedItem.expanded = true;
      setSelectedTreeItem(newSelectedItem);

      setselectFolderData(newSelectedItem);
    }
    $(".dialogue-inner-panel .k-overlay").click((event) => {
      props.onDialogClose(event);
    });
    setTimeout(() => {
      const elements = document.getElementsByClassName('k-in k-state-selected');
      if (elements.length > 0) {
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 1000);
    if (
      props.selectedFolder !== undefined &&
      props.selectedFolder.viewoption === 3
    ) {
      let usermasterobj = JSON.parse(sessionStorage.teamusercode);
      if (usermasterobj.length > 0) {
        setIsshowtosite(3);
      } else {
        props.props.alert.error(
          props.t("Orders.Sheetorders.IDS_LBL_NOTMAPPEDPROJECTTEAM", {
            showitem: "to me",
          })
        );
      }
    }
  }, [props, stateData]);


  const ongetmasterfailure = (response: any) => { };

  const handleOrderChange = (obj: any) => {
    const selectedId = obj;
    if (obj === null) {
      setselectOrderData([]);
      setsselectprotocolOrderData([]);
      //   return;
    } else if (screen === "Sheet") {
      if (obj.type === 5) {
        setselectSheetData(approveSheetData[0]);
      } else {
        setselectSheetData([]);
        setSheetData([]);
      }
      setselectOrderData(selectedId);
      setselectTestData([]); //
    } else {
      setselectTestData([]); //
      setProtocolItems([]); //
      setSelectedProtocol([]); //
      setsselectprotocolOrderData(selectedId);
    }
  };

  // const handleHover = () => {
  //   document.body.classList.toggle('modal-open');
  // };
  // const handleOutHover = () => {
  //   document.body.classList.toggle(' ');
  // }

  useEffect(() => {
    let passObjDet =
      store.getState().Loggeduser !== undefined &&
        store.getState().Loggeduser !== null &&
        Object.keys(store.getState().Loggeduser).length > 0
        ? store.getState().Loggeduser
        : {
          usercode: sessionStorage.User,
          username: sessionStorage.Username,
          lssitemaster: { sitecode: sessionStorage.Usersite },
        };

    Servicecalls("" + ELNurl + "/File/Gettaskforordercreate",
      passObjDet, (res: any) => { setTestData(res); }, ongetmasterfailure);
    Servicecalls("" + ELNurl + "/File/Getprojectforordercreate",
      passObjDet, (res: any) => { setProjectData(res); }, ongetmasterfailure);
    // Servicecalls("" + ELNurl + "/File/Getmaterialinventoryforordercreate",
    //   passObjDet, (res: any) => { setStateRepoData(res); }, ongetmasterfailure);
    Servicecalls("" + ELNurl + "/File/Getmaterialforordercreate",
      passObjDet, (res: any) => { setStateMaterial(res); }, ongetmasterfailure);
    Servicecalls("" + ELNurl + "/File/Getsampleforordercreate",
      passObjDet, (res: any) => {
        setStateSampleData(res);
      }, ongetmasterfailure);



    Servicecalls("" + ELNurl + "/File/GetMastersforordercreatesub",
      passObjDet, (res: any) => {
        const ApprovedSheets = res.sheets?.map((items: any) => {
          if (items.versionno) {
            items.filenameuser = items?.filenameuser + (items?.versionno !== undefined && items?.versionno !== null && items?.versionno !== "" && "_v" + (items?.versionno));
            return items;
          }
          return items;
        })
        setApproveSheetData(ApprovedSheets);
      }, ongetmasterfailure);

  }, []);

  React.useEffect(() => {
    if (screen === "Protocol") {
      if (
        ProtocolItems !== undefined &&
        ProtocolItems !== null &&
        ProtocolItems.length === 1 &&
        selectprotocolOrderData.type === 1
      ) {
        if (ProtocolItems[0].protocolmastercode !== -2) {
          setSelectedProtocol(ProtocolItems[0]);
        } else {
          setProtocolItems([]);
        }
      } else if (
        selectprotocolOrderData.type === 2 &&
        selectTestData !== undefined &&
        selectTestData !== null
      ) {
        let elntest = ProtocolItems.filter(
          (item: any) => item.protocolmastercode === -2
        );
        if (elntest.length === 0) {
          ProtocolItems.unshift({
            protocolmastercode: -2,
            protocolmastername: "Default Template",
          });
          setSelectedProtocol([]);
        }
      } else if (
        selectprotocolOrderData.type === 1 &&
        ProtocolItems.length > 0
      ) {
        let elntest = ProtocolItems.filter(
          (item: any) => item.protocolmastercode === -2
        );
        if (elntest.length > 0) {
          let elntest1 = ProtocolItems.filter(
            (item: any) => item.protocolmastercode !== -2
          );
          setProtocolItems(elntest1);
          if (
            SelectedProtocol !== undefined &&
            SelectedProtocol.protocolmastercode !== undefined
          ) {
            if (SelectedProtocol.protocolmastercode === -2) {
              setSelectedProtocol([]);
            }
          }
        } else if (
          SelectedProtocol !== undefined &&
          SelectedProtocol.protocolmastercode !== undefined
        ) {
          setSelectedProtocol([]);
        }
      }
    } else {
      if (
        selectOrderData.type === 3 &&
        selectTestData !== undefined &&
        selectTestData !== null
      ) {
        let elntest = sheetData.filter((item: any) => item.filecode === 1);
        if (elntest.length === 0 || elntest === undefined) {
          sheetData.unshift({ filecode: 1, filenameuser: "Default Template" });
          setselectSheetData([]);
        }
      } else if (selectOrderData.type !== 3 && sheetData.length > 0) {
        let elntestval = sheetData.filter(
          (item: any) => item.filenameuser === "Default Template"
        );
        if (elntestval.length > 0) {
          let elntest12 = sheetData.filter(
            (item: any) => item.filenameuser !== "Default Template"
          );
          setSheetData(elntest12);
          if (
            selectSheetData !== undefined &&
            selectSheetData !== null &&
            selectSheetData.filecode !== undefined
          ) {
            if (selectSheetData.filecode === 1) {
              setselectSheetData([]);
            }
          }
        } else if (
          selectOrderData.type !== 5 &&
          selectSheetData !== undefined &&
          selectSheetData !== null &&
          selectSheetData.filecode !== undefined
        ) {
          setselectSheetData([]);
        }
      }
    }
  }, [
    ProtocolItems,
    selectprotocolOrderData,
    selectTestData,
    selectOrderData,
    sheetData,
  ]); // eslint-disable-line react-hooks/exhaustive-deps
  //}, [])

  const handleTestChange = (obj: any) => {
    if (obj === null) {
      setselectTestData([]);
      setSheetData([]);
      setProtocolItems([]);
      setselectSheetData([]);
      setSelectedProtocol([]);
      //   return;
    } else {
      const selectedId = obj;
      setselectTestData(selectedId);
      if (screen === "Sheet") {
        let testPassObj = props.sessionvalues;
        testPassObj.testcode = obj.testcode;
        testPassObj.testtype = 1;

        testPassObj.objLoggeduser =
          props.sessionvalues.usercode !== undefined &&
            props.sessionvalues.username !== undefined &&
            props.sessionvalues.usercode !== null &&
            props.sessionvalues.username !== null
            ? {
              usercode: props.sessionvalues.usercode,
              username: props.sessionvalues.username,
            }
            : false;
        testPassObj.lssitemaster = {
          sitecode: sessionStorage.Usersite,
          sitename: sessionStorage.Usersitename,
        }

        Servicecalls(
          "" + ELNurl + "/File/GetfilesOnTestcode",
          testPassObj,
          ongetsheetsuccess,
          ongetsheetfailure
        );
      } else if (screen === "Protocol") {
        let passObjDet = {
          testcode: obj.testcode,
          testtype: 1,
          objLoggeduser: store.getState().Loggeduser,
          sitecode: sessionStorage.Usersite,
        };
        Servicecalls(
          "" + ELNurl + "/protocol/getProtocolOnTestcode",
          passObjDet,
          ongetsheetsuccess,
          ongetsheetfailure
        );
      }
    }
  };

  const ongetsheetsuccess = (response: any) => {
    if (screen === "Sheet") {
      response = response?.map((items: any) => {
        items.filenameuser = items?.filenameuser + (items?.versionno !== undefined && items?.versionno !== null && items?.versionno !== "" && "_v" + (items?.approved === 1 ? (items?.versionno) : (items?.versionno - 1)));
        return items;
      })
      setSheetData(response);
      // setselectSheetData(response)
      if (
        response !== undefined &&
        response !== null &&
        response.length > 0 &&
        response.length === 1
      ) {
        setselectSheetData(response[0]);
      } else if (
        response !== undefined &&
        response !== null &&
        response.length === 0
      ) {
        setselectSheetData([]);
        props.props.alert.error(
          props.t("Dashboard.Sheetorders.IDS_MSG_NOSHEET")
        );
      }
      // else {
      //   setselectSheetData(null);
      // }
    } else if (screen === "Protocol") {
      response = response?.map((items: any) => {
        items.protocolmastername = items?.protocolmastername + (items?.versionno !== undefined && items?.versionno !== null && items?.versionno !== "" && "_v" + (items?.approved === 1 ? (items?.versionno) : (items?.versionno - 1)));
        return items;
      })
      setProtocolItems(response);
      if (
        response !== undefined &&
        response !== null &&
        response.length > 0 &&
        response.length === 1
      ) {
        setSelectedProtocol(response[0]);
      } else if (
        response !== undefined &&
        response !== null &&
        response.length === 0 &&
        selectprotocolOrderData.type === 1
      ) {
        props.props.alert.error(
          props.t("Dashboard.Protocolorders.IDS_MSG_NOTASSIGNTEST")
        );
        setSelectedProtocol([]);
      }
    }
  };

  const ongetsheetfailure = () => { };

  const handleSheetChange = (obj: any) => {
    const selectedId = obj;
    if (screen === "Sheet") {
      setselectSheetData(selectedId);
    } else if (screen === "Protocol") {
      setSelectedProtocol(selectedId);
    }
  };
  // const generateNotetext = () => {
  //   const startdate = selectProjectData?.startdate;
  //   const enddate = selectProjectData?.enddate;

  //   if (startdate && enddate) {
  //     const formattedStartDate = new Date(startdate).toLocaleDateString('en-US');
  //     const formattedEndDate = new Date(enddate).toLocaleDateString('en-US');
  //     return `StartDate: ${formattedStartDate} - EndDate: ${formattedEndDate}`;
  //   }
  // };


  const handleProjectChange = (obj: any) => {
    const selectedId = obj;
    setselectProjectData(selectedId);

    if (selectWflowData !== null && selectWflowData?.usercode === -2) {
      Servicecalls(
        "" + ELNurl + "/User/GetUsersonprojectbased",
        selectedId,
        onGetUserUpdateSuccess,
        onGetUserUpdateFaliure
      );
    }

    if (obj !== null) {
      setFlows([
        {
          usercode: -1,
          username: props.t("Orders.Protocolorders.IDS_LBL_WORKFLOWNAME", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER") }),
        },
        {
          usercode: -2,
          username: props.t("Orders.Protocolorders.IDS_LBL_NOWORKFLOW", {
            param: "",
          }),
        },
      ]);
      setIsMoveParent(1);
    } else {
      setFlows([
        {
          usercode: -2,
          username: props.t("Orders.Protocolorders.IDS_LBL_NOWORKFLOW", {
            param: "",
          }),
        },
      ]);
      setIsMoveParent(4);
      setStateData(
        props.folderdata?.filter(
          (item: any) =>
            item.filefor === "PR" ||
            item.filefor === "DR" ||
            item.filefor === "SMM"
        )
      );
      // setStateData(
      //   formatData(
      //     removeDataItemandStaticFolder(
      //       props.folderdata,
      //       props.userData != null ? props.userData : { path: "-" }
      //     ),
      //     intl
      //   )
      // )
    }

    if (
      (selectWflowData === undefined || selectWflowData === null) &&
      obj !== null
    ) {
      setselectWflowData({
        usercode: -1,
        username: props.t("Orders.Protocolorders.IDS_LBL_WORKFLOWNAME", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER") }),
      });
    } else if (obj === null) {
      setselectWflowData(undefined);
    }
    // if (obj === null) {
    //   let passObjDet = props.sessionvalues;
    //   passObjDet.ismultitenant = isMultitenant;

    //   passObjDet.objuser = { teamusers: Getteamusersfromsession() };
    //   passObjDet.sitecode = props.sessionvalues.lssitemaster.sitecode;
    //   passObjDet.objLoggeduser = props.sessionvalues.objLoggeduser;
    //   Servicecalls(
    //     "" + ELNurl + "/User/GetUsersregister",
    //     passObjDet,
    //     onGetUserUpdateSuccess,
    //     onGetUserUpdateFaliure
    //   );
    // }
  };

  const handleSampleChange = (obj: any) => {
    const selectedId = obj;
    setselectSampleData(selectedId);

    if (obj !== null) {
      setFlows([
        {
          usercode: -1,
          username: props.t("Orders.Protocolorders.IDS_LBL_WORKFLOWNAME", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER") }),
        },
        {
          usercode: -2,
          username: props.t("Orders.Protocolorders.IDS_LBL_NOWORKFLOW", {
            param: "",
          }),
        },
      ]);
      setIsMoveParent(2);
    } else {
      setFlows([
        {
          usercode: -2,
          username: props.t("Orders.Protocolorders.IDS_LBL_NOWORKFLOW", {
            param: "",
          }),
        },
      ]);
      setIsMoveParent(4);
    }
  };

  const handleRepoChange = (obj: any) => {
    const selectedId = obj;
    setselectRepoData(selectedId);
    let repoPassObj = props.sessionvalues;
    repoPassObj.repositorycode = obj.repositorycode;
    repoPassObj.sitecode = props.sessionvalues.lssitemaster.sitecode;
    Servicecalls(
      "" + ELNurl + "/Master/Getallrepositoriesdata",
      repoPassObj,
      ongetrepodatasuccess,
      ongetrepodatafailure
    );
  };

  const onMaterialChange = (obj: any) => {
    const selectedId = obj;
    setselectMaterial(selectedId);
    // if (obj !== undefined && obj !== null) {
    //   let matPassObj = selectedId;
    //   matPassObj.nFlag = 4;
    //   Servicecalls(
    //     "" + ELNurl + "/transaction/getLoadOnInventoryData",
    //     matPassObj,
    //     onGetMaterialInventorySuccess,
    //     onGetMaterialInventoryFailure
    //   );
    // }
    if (obj !== null) {
      setFlows([
        {
          usercode: -1,
          username: props.t("Orders.Protocolorders.IDS_LBL_WORKFLOWNAME", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER") }),
        },
        {
          usercode: -2,
          username: props.t("Orders.Protocolorders.IDS_LBL_NOWORKFLOW", {
            param: "",
          }),
        },
      ]);
      setIsMoveParent(2);
    } else {
      setFlows([
        {
          usercode: -2,
          username: props.t("Orders.Protocolorders.IDS_LBL_NOWORKFLOW", {
            param: "",
          }),
        },
      ]);
      setIsMoveParent(4);
    }
  };

  const onMaterialInventoryChange = (obj: any) => {
    const selectedId = obj;
    setselectMaterialInventory(selectedId);
  };

  const onGetMaterialInventorySuccess = (res: any) => {
    // const materialObj = selectMaterial;
    // const listMaterialInventory = res.selectedMaterialInventory.filter((x: any) => {
    //   return x.nmaterialcode === materialObj.nmaterialcode
    // })
    setStateMaterialInventory(res.selectedMaterialInventory);
    setselectMaterialInventory(res.selectedMaterialInventory[0]);
  };

  const onGetMaterialInventoryFailure = (res: any) => { };

  const ongetrepodatasuccess = (response: any) => {
    setStateRepodataData(response);
    if (response !== undefined && response !== null && response.length > 0) {
      setselectRepodataData(response[0]);
    }
  };

  const ongetrepodatafailure = () => { };

  const handleRepodataChange = (obj: any) => {
    const selectedId = obj;
    setselectRepodataData(selectedId);
  };

  const handleWflowChange = (obj: any) => {
    const selectedId = obj;
    setselectWflowData(selectedId);
    if (
      obj !== null &&
      obj.usercode === -2 &&
      selectProjectData === undefined
    ) {
      let passObjDet = props.sessionvalues;
      passObjDet.ismultitenant = isMultitenant;

      passObjDet.objuser = { teamusers: Getteamusersfromsession() };
      passObjDet.sitecode = props.sessionvalues.lssitemaster.sitecode;
      passObjDet.objLoggeduser = props.sessionvalues.objLoggeduser;
      Servicecalls(
        "" + ELNurl + "/User/GetUsersregister",
        passObjDet,
        onGetUserUpdateSuccess,
        onGetUserUpdateFaliure
      );
    } else if (
      obj !== null &&
      obj.usercode === -2 &&
      selectProjectData !== undefined
    ) {
      Servicecalls(
        "" + ELNurl + "/User/GetUsersonprojectbased",
        selectProjectData,
        onGetUserUpdateSuccess,
        onGetUserUpdateFaliure
      );
    } else {
      setselectUser(null);
      setStateData(
        formatData(
          removeDataItemandStaticFolder(
            props.folderdata,
            props.userData != null ? props.userData : { path: "-" }
          ),
          intl
        )
      );
      // getdirectory(false, undefined);
    }
  };

  const handleuserChange = (obj: any) => {
    setselectUser(obj);
    getdirectory(true, obj);
  };

  const onGetUserUpdateSuccess = (response: any) => {
    if (response !== undefined) {
      response = response.filter(
        (item: any) =>
          item.userstatus === props.t("Setup.Usermaster.IDS_LBL_ACTIVE") && item.username !== undefined
      );
      setUsers(response);
      if (response !== undefined && response !== null && response.length > 0) {
        setselectUser(response[0]);
        getdirectory(true, response[0]);
      } else {
        setselectUser(null);
      }
    }
  };
  const onGetUserUpdateFaliure = (response: any) => { };

  const onOrderKeywordEnter = (response: any) => {
    setselectOrderKey(response);
  };

  const onOrdertittleEnter = (response: any) => {
    setSelectOrdertittle(response);
  };

  const handleTreeItemClick = (event: TreeViewItemClickEvent) => {
    const newSelectedItem: DataModel = searchTreeItem(stateData, event.item);
    newSelectedItem.expanded =
      event.item.expanded !== undefined ? !event.item.expanded : true;

    setSelectedTreeItem(newSelectedItem);
    setSelected_Path(newSelectedItem?.filefor === "DR" ? newSelectedItem?.path?.replace(/\//g, " -> ") || "" : "")
    setTreeClicked(!treeClicked);
  };

  const handleAutoRegisterCheck = (event: any) => {
    console.log(event.target.checked);
    if (event.target.checked) {
      setIsAutoRegister(event.target.checked);

      //  setIsDueDateChecked(null);
    } else {
      setIsAutoRegister(false);
      setInterval([]);
      setDurationvalue([]);
      // setIsDueDateChecked(true);
    }
  }
  const onInterval = (response: any) => {
    setInterval(response);
    IntervalDurationCalculation(response, null);
  }
  const onHandleDurationValueChange = (event: any) => {
    console.log(event)
    setDurationvalue(event);
    IntervalDurationCalculation(null, event);
  }

  const IntervalDurationCalculation = (Intervalres: any, Durationres: any) => {
    console.log(Intervalres);
    console.log(Durationres);
    let periodchoosed; let intervalrate = undefined;

    if (Durationres !== null) {
      setDurationvalue(Durationres);
      periodchoosed = Durationres.name;
    } else if (Intervalres !== null) {
      setInterval(Intervalres);
      intervalrate = Intervalres;
    }

    if (Durationvalue !== undefined && Durationvalue !== null && Object.keys(Durationvalue).length > 0) {
      if (Durationres === null) {
        periodchoosed = Durationvalue.name;
      }
    }

    if (Interval !== undefined) {
      if (Intervalres === null) {
        intervalrate = Interval;
      }
    }

    //let periodchoosed = event.name;
    let today = new Date();
    if (intervalrate !== undefined && intervalrate !== "" && periodchoosed && periodchoosed.length > 0) {
      if (periodchoosed === "Weeks") {
        today.setDate(today.getDate() + Number(intervalrate * 7));
        setautoregisterdate(today);
      } else if (periodchoosed === "Days") {
        today.setDate(today.getDate() + Number(intervalrate));
        setautoregisterdate(today);
      }
      else if (periodchoosed === "Hours") {
        today.setHours(today.getHours() + Number(intervalrate));
        setautoregisterdate(today);
      }
      else if (periodchoosed === "Minutes") {
        today.setMinutes(today.getMinutes() + 2);
        setautoregisterdate(today);
      }
    }
  }


  const onSpellDayEnter = (response: any) => {
    if (/^\d+$/.test(response) && response !== "0") {
      setSpellBefore(response);
      //setperiodsvalue([]);
      duecautioncalculation(null, response);
    } else {
      props.props.alert.error(props.t("Common.IDS_MSG_VALIDINPUT"));
      setSpellBefore([]);
    }

  };

  const handleDueDateCheck = (event: any) => {
    console.log(event.target.checked);

    if (event.target.checked) {
      let currentdate = new Date();
      // let  mindate=currentdate.getDate()+1;
      // let setminDate=new Date(currentdate.setDate(mindate));
      //   setduedate(setminDate);
      setduedate(currentdate);
      setSpellBefore([]);
      setcurrentday(new Date());
      //setIsAutoRegister(null);
      setIsDueDateChecked(event.target.checked);
    } else {
      setperiodsvalue([]);
      // setIsAutoRegister(true);
      setIsDueDateChecked(false);
    }
  }

  const onDatachange = (event: any) => {
    console.log(event);
    console.log(SpellBefore);
    setduedate(event.value);
    setperiodsvalue([]);
    setSpellBefore([]);
    setcurrentday(event.value);
  }


  const handleTimePickerVisibility = () => {
    setShowTimePicker(duedate.getDate() === new Date().getDate());
    //setShowTimePicker(new Date().getTime());
    setperiodsvalue([]);
    setSpellBefore([]);
  };

  const timechange = (event: any) => {
    //setShowTimePicker(duedate.getDate() === new Date().getDate());
    setcurrentday(event.target.value);
    //setduedate(event.target.value);
    setperiodsvalue([]);
    setSpellBefore([]);
  }


  const compareTime = (date1: any, date2: any) => {
    const hours1 = date1.getUTCHours();
    const minutes1 = date1.getUTCMinutes();
    const seconds1 = date1.getUTCSeconds();

    const hours2 = date2.getUTCHours();
    const minutes2 = date2.getUTCMinutes();
    const seconds2 = date2.getUTCSeconds();

    if (hours1 !== hours2) {
      return hours1 - hours2;
    }
    if (minutes1 !== minutes2) {
      return minutes1 - minutes2;
    }
    if (seconds1 !== seconds2) {
      return seconds1 - seconds2;
    }

    // If time components are equal
    return 0;
  };

  const duecautioncalculation = (periodres: any, spellbeforeres: any) => {

    console.log(duedate);
    console.log(SpellBefore);

    let periodchoosed; let SpellBeforerate = undefined;

    if (periodres !== null) {
      setperiodsvalue(periodres);
      periodchoosed = periodres.name;
    } else if (spellbeforeres !== null) {
      setSpellBefore(spellbeforeres);
      SpellBeforerate = spellbeforeres;
    }

    if (periodsvalue !== undefined && periodsvalue !== null && Object.keys(periodsvalue).length > 0) {
      if (periodres === null) {
        periodchoosed = periodsvalue.name;
      }
    }

    if (SpellBefore.length > 0) {
      if (spellbeforeres === null) {
        SpellBeforerate = SpellBefore;
      }
    }

    const timestamp = currentday;
    const date = new Date(timestamp);

    const copiedEvent = {
      type: 'custom',
      timestamp: date
    };

    if (SpellBeforerate !== undefined && periodchoosed && periodchoosed.length > 0) {
      if (periodchoosed === "Weeks") {
        copiedEvent.timestamp.setDate(copiedEvent.timestamp.getDate() - (SpellBeforerate * 7));
        if (copiedEvent.timestamp < new Date()) {
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_INVALIDDATE"));
          setperiodsvalue([]);
          setSpellBefore([]);

        } else {
          setcurrentDayuserdefstate(copiedEvent.timestamp);
        }
      } else if (periodchoosed === "Days") {
        copiedEvent.timestamp.setDate(copiedEvent.timestamp.getDate() - (SpellBeforerate));

        if (copiedEvent.timestamp < new Date()) {
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_INVALIDDATE"));
          setperiodsvalue([]);
          setSpellBefore([]);

        } else {
          setcurrentDayuserdefstate(copiedEvent.timestamp);
        }
      } else if (periodchoosed === "Months") {
        copiedEvent.timestamp.setMonth(copiedEvent.timestamp.getMonth() - (SpellBeforerate));
        if (copiedEvent.timestamp < new Date()) {
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_INVALIDDATE"));
          setperiodsvalue([]);
          setSpellBefore([]);

        } else {
          setcurrentDayuserdefstate(copiedEvent.timestamp);
        }
      } else if (periodchoosed === "Hours") {
        const timestamp = currentday;
        const date = new Date(timestamp);

        const currentdaycopy = {
          type: 'custom',
          timestamp: date
        };

        // currentdaycopy.timestamp.setHours(currentdaycopy.timestamp.getHours() - (SpellBeforerate));
        currentdaycopy.timestamp.setMinutes(currentdaycopy.timestamp.getMinutes() - 15);
        console.log(currentdaycopy.timestamp)
        const day1 = currentdaycopy.timestamp.getDate();
        const day2 = new Date().getDate();

        if (day1 === day2) {
          const comparisonResult = compareTime(currentdaycopy.timestamp, new Date());

          if (comparisonResult > 0) {
            console.log('Time of date1 is later than time of date2');
            setcurrentDayuserdefstate(currentdaycopy.timestamp);
          } else if (comparisonResult < 0) {
            console.log('Time of date1 is earlier than time of date2');
            props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_INVALIDDATE"));
            setperiodsvalue([]);
            setSpellBefore([]);

          } else {
            console.log('Time of date1 is the same as time of date2');
          }
        }
        else if (currentdaycopy.timestamp < new Date()) {
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_INVALIDDATE"));
          setperiodsvalue([]);
          setSpellBefore([]);

        } else {
          setcurrentDayuserdefstate(currentdaycopy.timestamp);
        }

      } if (periodchoosed === "Minutes") {
        const timestamp = currentday;
        const date = new Date(timestamp);

        const currentdaycopy = {
          type: "custom",
          timestamp: date
        };

        // ⏱ subtract minutes instead of hours
        currentdaycopy.timestamp.setMinutes(
          currentdaycopy.timestamp.getMinutes() - SpellBeforerate
        );

        const day1 = currentdaycopy.timestamp.getDate();
        const day2 = new Date().getDate();

        if (day1 === day2) {
          const comparisonResult = compareTime(currentdaycopy.timestamp, new Date());

          if (comparisonResult > 0) {
            // valid future time
            setcurrentDayuserdefstate(currentdaycopy.timestamp);
          } else if (comparisonResult < 0) {
            // invalid past time
            props.props.alert.error(
              props.t("Orders.Sheetorders.IDS_MSG_INVALIDDATE")
            );
            setperiodsvalue([]);
            setSpellBefore([]);
          }
        } else if (currentdaycopy.timestamp < new Date()) {
          // different day but already past
          props.props.alert.error(
            props.t("Orders.Sheetorders.IDS_MSG_INVALIDDATE")
          );
          setperiodsvalue([]);
          setSpellBefore([]);
        } else {
          // future date
          setcurrentDayuserdefstate(currentdaycopy.timestamp);
        }
      }
      else if (periodchoosed === "Years") {

        copiedEvent.timestamp.setFullYear(copiedEvent.timestamp.getFullYear() - (SpellBeforerate));
        if (copiedEvent.timestamp < new Date()) {
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_INVALIDDATE"));
        } else {
          setcurrentDayuserdefstate(copiedEvent.timestamp);
        }
      }
    }

  }


  const onHandleOpenExpPeriodChange = (event: any) => {
    console.log(event)
    setperiodsvalue(event);
    duecautioncalculation(event, null);
  }

  const handleContextMenuView = (event: ContextMenuEvent) => { };

  const onprojectteamchange = (event: any) => {
    console.log(event);

    let selectedteamcode = event.selectedteam;
    let userteam = event.usersteam;
    let lsselectedTeam: any = [];

    selectedteamcode.map((code: any) => {
      let usersteam: any = {}
      if (code !== "") {
        usersteam.teamcode = parseInt(code);
        let selectedTeam: any = {
          userteam: usersteam
        };
        lsselectedTeam.push(selectedTeam);
      }

    })
    setSelectedProjectTeam(lsselectedTeam);
  }

  const onexistingfolder = (response: any) => {
    setSelectedTreeItem(selectFolderData);
    setIsMoveParent(parseInt(response.target.value));
  };

  const onselectfolder = (event: any) => {
    setSelectedTreeItem(event);
    setIsMoveParent(parseInt(event.target.value));
  };

  const onsaveonproject = (event: any) => {
    setIsMoveParent(parseInt(event.target.value));
  };

  const onsaveonsample = (event: any) => {
    setIsMoveParent(parseInt(event.target.value));
  };

  const onshowtosite = (event: any) => {
    if (
      props.selectedFolder !== undefined &&
      props.selectedFolder.viewoption === 3 &&
      (parseInt(event.target.value) !== 3 || parseInt(event.target.value) !== 2)
    ) {
      props.props.alert.error(
        props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWSITEVAL", {
          showitem: "to Team",
        })
      );
    } else if (
      props.selectedFolder !== undefined &&
      props.selectedFolder.viewoption === 2 &&
      (parseInt(event.target.value) !== 2 || parseInt(event.target.value) !== 3)
    ) {
      props.props.alert.error(
        props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWOPTION", {
          showitem: "to me",
        })
      );
    } else {
      setIsshowtosite(parseInt(event.target.value));
      // setSelectuserteam(undefined);
    }
  };
  // const handleprojectteamChange = (obj: any) => {
  //   setSelectuserteam(obj);
  // }

  // const onGetProjectTeamFailure = (response: any) => { }

  const onshowonlytome = (event: any) => {
    if (
      props.selectedFolder !== undefined &&
      props.selectedFolder.viewoption === 3 &&
      parseInt(event.target.value) !== 3 &&
      parseInt(event.target.value) !== 2
    ) {
      props.props.alert.error(
        props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWSITEVAL", {
          showitem: "to Team",
        })
      );
    } else if (
      props.selectedFolder !== undefined &&
      props.selectedFolder.viewoption === 2 &&
      (parseInt(event.target.value) !== 2 || parseInt(event.target.value) !== 3)
    ) {
      props.props.alert.error(
        props.t("Orders.Sheetorders.IDS_LBL_FOLDERVIEWOPTION", {
          showitem: "to me",
        })
      );
    } else if (parseInt(event.target.value) === 3) {
      let usermasterobj = JSON.parse(sessionStorage.teamusercode);
      if (usermasterobj.length > 0) {
        setIsshowtosite(parseInt(event.target.value));
      } else {
        props.props.alert.error(
          props.t("Orders.Sheetorders.IDS_LBL_NOTMAPPEDPROJECTTEAM", {
            showitem: "to me",
          })
        );
      }
    } else {
      setIsshowtosite(parseInt(event.target.value));
    }
  };

  const handleRegisterOrderClick = (event: any) => {

    const userWorkflows = sessionStorage?.Userworkflows && JSON.parse(sessionStorage?.Userworkflows);
    const userWorkflows_protocol = sessionStorage?.Protocol_Userworkflows && JSON.parse(sessionStorage?.Protocol_Userworkflows);
    const callcreateDialogAction = () => {
      document.body.classList.remove("overflow");
      if (isMultitenant === 2 && screen === "Sheet" || screen === "Sheet" && selectOrderKey !== "") {
        if (!validateBeforeRegister()) return;
        props.onCreateDialogClick({
          event,
          type: event.target.value,
          selectOrderData: selectOrderData,
          selectTestData: selectTestData,
          selectSheetData: selectSheetData,
          selectProjectData: selectProjectData,
          selectSampleData: selectSampleData,
          selectRepoData: selectRepoData,
          selectRepodataData: selectRepodataData,
          selectMaterial: selectMaterial,
          selectMaterialInventory: selectMaterialInventory,
          selectWflowData: selectWflowData,
          selectOrderKey: selectOrderKey,
          selectassigneduser: selectUser,
          selectOrdertittle: selectOrdertittle,
          selectFolderData: selectedTreeItem?.filefor === "DR" ? selectedTreeItem : null,
          orderdisplaytype: isMoveParent,
          viewoption: isshowtosite,
          duedate: currentday,
          cautiondate: currentDayuserdefstate,
          period: periodsvalue,
          Repeat: isAutoRegister,
          Interval: Interval,
          timespan: Durationvalue,
          autocreatedate: autoregisterdate,
          Autoregister_Count: Autoregister_Count,
          selectedprojectteam: selectedprojectteam
        });
      } else if (isMultitenant === 2 && screen === "Protocol" || screen === "Protocol" && selectOrderKey !== "") {
        if (!validateBeforeRegisteronprotocol()) return;
        props.onCreateDialogClick({
          event,
          type: event.target.value,
          selectprotocolOrderData: selectprotocolOrderData,
          selectTestData: selectTestData,
          SelectedProtocol: SelectedProtocol,
          selectProjectData: selectProjectData,
          selectSampleData: selectSampleData,
          selectRepoData: selectRepoData,
          selectRepodataData: selectRepodataData,
          selectWflowData: selectWflowData,
          selectOrderKey: selectOrderKey,
          selectOrdertittle: selectOrdertittle,
          selectassigneduser: selectUser,
          selectMaterial: selectMaterial,
          selectMaterialInventory: selectMaterialInventory,
          selectFolderData: selectedTreeItem?.filefor === "DR" ? selectedTreeItem : null,
          orderdisplaytype: isMoveParent,
          viewoption: isshowtosite,
          duedate: currentday,
          cautiondate: currentDayuserdefstate,
          period: periodsvalue,
          Repeat: isAutoRegister,
          Interval: Interval,
          timespan: Durationvalue,
          autocreatedate: autoregisterdate,
          Autoregister_Count: Autoregister_Count,
          selectedprojectteam: selectedprojectteam
        });
      } else {
        props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_KEYWORD"));
      }
    }

    if (screen === "Sheet" && Array.isArray(userWorkflows) && userWorkflows?.length === 0 && selectWflowData?.usercode === -1 || screen === "Protocol" && Array.isArray(userWorkflows_protocol) && userWorkflows?.length === 0 && selectWflowData?.usercode === -1) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert-body">
              <h1>
                {props.t("Masters.Taskmaster.IDS_LBL_CONFIRM", { param: "", })}
              </h1>
              <p>
                {"User is not a part of Workflow. Should I continue ?"}
              </p>
              <div className="react-confirm-alert-button-group">
                <button id="id-taskmaster-retire"
                  onClick={() => {
                    callcreateDialogAction();
                    onClose();
                  }}
                >
                  {props.t("Masters.Taskmaster.IDS_LBL_YES", { param: "", })}
                </button>
                <button id="id-taskmaster-close" onClick={onClose}>
                  {props.t("Masters.Taskmaster.IDS_LBL_NO", { param: "", })}
                </button>
              </div>
            </div>
          );
        },
      });
    } else {
      callcreateDialogAction();
    }
  };

  const validateBeforeRegister = () => {
    let isvalidate = true;
    if (Object.keys(selectOrderData).length === 0) {
      isvalidate = false;
      props.props.alert.error(
        props.t("Orders.Sheetorders.IDS_MSG_SELECTORDERTYPE")
      );
    }
    let stateDatacopy = stateData === undefined || stateData === null ? [] : stateData;

    if (
      isvalidate &&
      (selectOrderData.type === 2 || selectOrderData.type === 3)
    ) {
      if (isMoveParent === 4 && stateData.length === 0) {
        isvalidate = false;
        props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_NOFOLDER"));
      } else if (selectTestData === undefined || selectTestData === null || Object.keys(selectTestData).length === 0) {
        isvalidate = false;
        props.props.alert.error(
          props.t("Orders.Sheetorders.IDS_MSG_SELECTTASK")
        );
      } else if (
        selectSheetData === undefined ||
        selectSheetData === null ||
        Object.keys(selectSheetData).length === 0
      ) {
        isvalidate = false;
        props.props.alert.error(
          props.t("Orders.Sheetorders.IDS_MSG_SELECTSHEET")
        );
      } else if (
        // (selectProjectData === undefined || selectProjectData === null) &&
        // (selectMaterial === undefined || selectMaterial === null) &&
        // selectedTreeItem?.filefor !== "DR"
        (stateDatacopy?.length === 0 && (selectProjectData === undefined || selectProjectData === null) && (selectMaterial === undefined || selectMaterial === null)) ||
        (stateDatacopy?.length > 0 && (selectProjectData === undefined || selectProjectData === null) && (selectMaterialInventory === undefined || selectMaterialInventory === null) && selectedTreeItem?.filefor !== "DR") ||
        (selectedTreeItem?.filefor !== "DR" && stateDatacopy.length > 0)
      ) {
        isvalidate = false;
        props.props.alert.error(
          props.t("Dashboard.Protocolorders.IDS_LBL_NOSELECTFOLDER")
        );
      } else if (isMultitenant !== 2 && selectOrderKey === undefined || isMultitenant !== 2 && selectOrderKey.trim() === "") {
        isvalidate = false;
        props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_KEYALERT"));
      }
      else if (isDueDateChecked) {
        if (periodsvalue === undefined || periodsvalue.length === 0 || periodsvalue === null) {
          isvalidate = false;
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERPERIOD"));
        } if (SpellBefore === undefined || SpellBefore.length === 0 || SpellBefore === null) {
          isvalidate = false;
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERNOTIFY"));
        }
      }
      else if (isAutoRegister) {
        if (Interval === undefined || Interval.length === 0 || Interval === null || Interval === "") {
          isvalidate = false;
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERINTERVAL"));
        } else if (Durationvalue === undefined || Durationvalue.length === 0 || Durationvalue === null) {
          isvalidate = false;
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERDURATION"));
        } else if ((Autoregister_Count === undefined) || (Autoregister_Count === 0) || (Autoregister_Count === "")) {
          isvalidate = false;
          props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERAUTOREGISTERCOUNT"));
        }
      } else if (isshowtosite === 3 && selectedprojectteam.length === 0 && (selectProjectData === undefined || selectProjectData === null)) {
        isvalidate = false;
        props.props.alert.error(
          props.t("Dashboard.Protocolorders.IDS_LBL_NOSELECTUSERTEAM")
        );
      }
    } else if (
      selectOrderData.type === 5 &&
      (selectSheetData === undefined || selectSheetData === null)
    ) {
      isvalidate = false;
      props.props.alert.error(
        props.t("Orders.Sheetorders.IDS_MSG_SELECTSHEET")
      );
    } else if (
      (selectOrderData.type === 5 || selectOrderData.type === 4) &&
      // (selectProjectData === undefined || selectProjectData === null) &&
      // (selectMaterial === undefined || selectMaterial === null) &&
      // selectedTreeItem?.filefor !== "DR"
      (stateDatacopy?.length === 0 && (selectProjectData === undefined || selectProjectData === null) && (selectMaterial === undefined || selectMaterial === null)) ||
      (stateDatacopy?.length > 0 && (selectProjectData === undefined || selectProjectData === null) && (selectMaterialInventory === undefined || selectMaterialInventory === null) && selectedTreeItem?.filefor !== "DR") ||
      (selectedTreeItem?.filefor !== "DR" && stateDatacopy.length > 0)
    ) {
      isvalidate = false;
      props.props.alert.error(
        props.t("Dashboard.Protocolorders.IDS_LBL_NOSELECTFOLDER")
      );
    } else if (isMultitenant !== 2 && selectOrderKey === undefined || isMultitenant !== 2 && selectOrderKey === "") {
      isvalidate = false;
      props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_KEYALERT"));
    } else if (isshowtosite === 3 && selectedprojectteam.length === 0 && (selectProjectData === undefined || selectProjectData === null)) {
      isvalidate = false;
      props.props.alert.error(
        props.t("Dashboard.Protocolorders.IDS_LBL_NOSELECTUSERTEAM")
      );
    }
    return isvalidate;
  };

  const validateBeforeRegisteronprotocol = () => {
    let isvalidate = true;
    let stateDatacopy = stateData === undefined || stateData === null ? [] : stateData;
    if (Object.keys(selectprotocolOrderData).length === 0) {
      isvalidate = false;
      props.props.alert.error(
        props.t("Orders.Sheetorders.IDS_MSG_SELECTORDERTYPE")
      );
    }
    if (isMoveParent === 4 && stateData.length === 0) {
      isvalidate = false;
      props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_NOFOLDER"));
    } else if (
      isvalidate &&
      selectTestData !== undefined &&
      selectTestData !== null &&
      Object.keys(selectTestData).length > 0
    ) {
      if (
        SelectedProtocol === undefined ||
        SelectedProtocol === null ||
        Object.keys(SelectedProtocol).length === 0
      ) {
        isvalidate = false;
        props.props.alert.error(
          props.t("Orders.Sheetorders.IDS_MSG_NOPROTOCOLSELECT")
        );
      }
    } else {
      isvalidate = false;
      props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_SELECTTASK"));
    }

    if (isMultitenant !== 2 && selectOrderKey === undefined || isMultitenant !== 2 && selectOrderKey.trim() === "") {
      isvalidate = false;
      props.props.alert.error(
        props.t("Orders.Protocolorders.IDS_MSG_KEYALERT")
      );
    }

    else if (isDueDateChecked) {
      if (periodsvalue === undefined || periodsvalue.length === 0 || periodsvalue === null) {
        isvalidate = false;
        props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERPERIOD"));
      } if (SpellBefore === undefined || SpellBefore.length === 0 || SpellBefore === null) {
        isvalidate = false;
        props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERNOTIFY"));
      }
    }
    else if (isAutoRegister) {
      if (Interval === undefined || Interval.length === 0 || Interval === null || Interval === "") {
        isvalidate = false;
        props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERINTERVAL"));
      } else if (Durationvalue === undefined || Durationvalue.length === 0 || Durationvalue === null) {
        isvalidate = false;
        props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERDURATION"));
      } else if ((Autoregister_Count === undefined) || (Autoregister_Count === 0) || (Autoregister_Count === "")) {
        isvalidate = false;
        props.props.alert.error(props.t("Orders.Sheetorders.IDS_MSG_ENTERAUTOREGISTERCOUNT"));
      }
    }

    else if (
      // (selectProjectData === undefined || selectProjectData === null) &&
      // (selectMaterial === undefined || selectMaterial === null) &&
      // selectedTreeItem?.filefor !== "DR"
      (stateDatacopy?.length === 0 && (selectProjectData === undefined || selectProjectData === null) && (selectMaterial === undefined || selectMaterial === null)) ||
      (stateDatacopy?.length > 0 && (selectProjectData === undefined || selectProjectData === null) && (selectMaterialInventory === undefined || selectMaterialInventory === null) && selectedTreeItem?.filefor !== "DR") ||
      (selectedTreeItem?.filefor !== "DR" && stateDatacopy.length > 0)
    ) {
      isvalidate = false;
      props.props.alert.error(
        props.t("Dashboard.Protocolorders.IDS_LBL_NOSELECTFOLDER")
      );
    } else if (isshowtosite === 3 && selectedprojectteam.length === 0 && (selectProjectData === undefined || selectProjectData === null)) {
      isvalidate = false;
      props.props.alert.error(
        props.t("Dashboard.Protocolorders.IDS_LBL_NOSELECTUSERTEAM")
      );
    }


    return isvalidate;
  };



  const handleCreateDialogClose = () => {
    props.onDialogClose();

    document.body.classList.remove("overflow");
  };

  return (
    <div id="Order_Registration">
      <DialogComponent
        className="dialogue-inner-panel fixed-dashboard"
        title={props.t("Orders.Sheetorders.IDS_LBL_CREATEORDER", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASKS") : props.t("Header.IDS_LBL_ORDER") })}
        onClose={handleCreateDialogClose}
      >
        <div style={{ height: "75vh" }}>
          <div className="row clearfix">
            <div className="col-12">
              <div className="split-form-ordered form-group-half">
                <div className="form-group">
                  <label htmlFor="inputPassword" className="form-label">
                    <span className="label-top required">
                      {isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASKTYPE") : props.t("Orders.Sheetorders.IDS_LBL_ORDERTYPE")}
                    </span>
                  </label>
                  {screen === "Sheet" ? (
                    <KendoCombobox
                      initialValue=""
                      id="id-combo-sheetorder"
                      Datasource={splitBtnItems}
                      DefaultValue={selectOrderData}
                      onvaluechange={handleOrderChange}
                      ValueMember="type"
                      DisplayMember="name"
                      Placeholder={isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASKTYPE") : props.t("Orders.Sheetorders.IDS_LBL_ORDERTYPE")}
                    />
                  ) : (
                    <KendoCombobox
                      initialValue=""
                      id="id-combo-protocolorder"
                      Datasource={splitprotocolorderitems}
                      DefaultValue={selectprotocolOrderData}
                      onvaluechange={handleOrderChange}
                      ValueMember="type"
                      DisplayMember="name"
                      Placeholder={isMultitenant === 2 ? props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDERTYPE")}
                    />
                  )}
                </div>
                {selectOrderData !== undefined && selectOrderData !== null && (
                  <div className="form-group">
                    <label htmlFor="inputPassword" className="form-label">
                      <span className="label-top">
                        {props.t("Orders.Sheetorders.IDS_LBL_SELECTPROJECTS")}
                      </span>
                    </label>

                    <KendoCombobox
                      id="id-combo-project"
                      initialValue=""
                      Datasource={projectData}
                      DefaultValue={selectProjectData}
                      onvaluechange={handleProjectChange}
                      ValueMember="projectcode"
                      DisplayMember="projectname"
                      Placeholder={props.t("Orders.Sheetorders.IDS_LBL_PROJECT")}
                    />
                    {/* {selectProjectData && (
                      <div className="col-sm-12" >
                        <div className="steps-highlight p-0 border-0 mb-0 mt-2">
                          <small>
                            <span className="semi-dark"><b>
                              {props.t("Header.IDS_LBL_NOTE", { param: "" })}:
                              <span className="date-label">
                              </span>
                            </b></span>
                            {generateNotetext()}
                          </small>
                        </div>
                      </div>
                    )} */}

                  </div>
                )}
                {selectOrderData !== undefined &&
                  selectOrderData !== null &&
                  selectOrderData.type !== 4 &&
                  selectOrderData.type !== 5 && (
                    <div className="form-group">
                      <label htmlFor="inputPassword" className="form-label">
                        <span className="label-top required">
                          {props.t("Orders.Sheetorders.IDS_LBL_TASK")}
                        </span>
                      </label>

                      <KendoCombobox
                        initialValue=""
                        id="id-combo-task"
                        Datasource={testData}
                        DefaultValue={selectTestData}
                        onvaluechange={handleTestChange}
                        ValueMember="testcode"
                        DisplayMember="testname"
                        Placeholder={props.t("Orders.Sheetorders.IDS_LBL_TASK")}
                      />
                    </div>
                  )}

                {selectOrderData !== undefined &&
                  selectOrderData !== null &&
                  selectOrderData.type !== 5 &&
                  (isMultitenant === 2 || isPremiumTenant || isMultitenant === 0 ? (
                    <div className="form-group inventory-outerbox">
                      <label htmlFor="inputPassword" className="form-label">
                        {props.t("Dashboard.IDS_LBL_SELECTAMATERIAL")}
                      </label>
                      <Suspense fallback={<div></div>}>
                        <KendoCombobox
                          initialValue=""
                          id="id-combo-material"
                          className={selectOrderData.type == 4 ? "inventory_comboboxright" : "inventory_combobox"}
                          Datasource={stateMaterial}
                          DefaultValue={selectMaterial}
                          onvaluechange={onMaterialChange}
                          ValueMember="matcode"
                          DisplayMember="matname"
                          Placeholder={props.t(
                            "Dashboard.IDS_LBL_SELECTAMATERIAL"
                          )}
                        />
                      </Suspense>
                    </div>
                  ) : (
                    <div className="form-group">
                      <label htmlFor="inputPassword" className="form-label">
                        {props.t("Orders.Sheetorders.IDS_LBL_INVENTORY")}
                      </label>
                      <KendoCombobox
                        initialValue=""
                        id="id-combo-repository"
                        Datasource={stateRepoData}
                        DefaultValue={selectRepoData}
                        onvaluechange={handleRepoChange}
                        ValueMember="invencode"
                        DisplayMember="invenid"
                        Placeholder={props.t(
                          "Orders.Sheetorders.IDS_LBL_INVENTORY"
                        )}
                      />
                    </div>
                  ))
                }

                {screen === "Sheet"
                  ? selectOrderData !== undefined &&
                  selectOrderData !== null &&
                  selectOrderData.type !== 4 && (
                    <div className="form-group">
                      <label htmlFor="inputPassword" className="form-label">
                        <span className="label-top required">
                          {props.t("Orders.Sheetorders.IDS_LBL_SELECTSHEET")}
                        </span>
                      </label>

                      <KendoCombobox
                        initialValue=""
                        id="id-combo-sheet"
                        Datasource={
                          selectOrderData.type === 2 ||
                            selectOrderData.type === 3
                            ? sheetData
                            : selectOrderData && selectOrderData.type ? approveSheetData : selectTestData ? sheetData : []
                        }
                        DefaultValue={selectSheetData}
                        onvaluechange={handleSheetChange}
                        ValueMember="filecode"
                        DisplayMember="filenameuser"
                        Placeholder={props.t(
                          "Orders.Sheetorders.IDS_LBL_SHEET"
                        )}
                      />
                    </div>
                  )
                  : selectprotocolOrderData !== undefined &&
                  selectprotocolOrderData !== null && (
                    <div className="form-group">
                      <label htmlFor="inputPassword" className="form-label">
                        <span className="label-top required">
                          {props.t(
                            "Templates.Protocoltemplates.IDS_LBL_PROTOCOLNAME"
                          )}
                        </span>
                      </label>

                      <KendoCombobox
                        initialValue=""
                        id="id-combo-protocol"
                        Datasource={ProtocolItems}
                        onvaluechange={handleSheetChange}
                        DefaultValue={SelectedProtocol}
                        ValueMember="protocolmastercode"
                        DisplayMember="protocolmastername"
                        Placeholder={props.t(
                          "Templates.Protocoltemplates.IDS_LBL_PROTOCOLNAME",
                          {
                            param: "",
                          }
                        )}
                      />
                    </div>
                  )
                }

                {selectOrderData !== undefined &&
                  selectOrderData !== null &&
                  selectOrderData.type !== 5 && (
                    <div className="form-group">
                      <label htmlFor="inputPassword" className="form-label">
                        {props.t("Orders.Sheetorders.IDS_LBL_SELECTSAMPLE")}
                      </label>

                      <KendoCombobox
                        initialValue=""
                        id="id-combo-sample"
                        Datasource={stateSampleData}
                        DefaultValue={selectSampleData}
                        onvaluechange={handleSampleChange}
                        ValueMember="samplecode"
                        DisplayMember="samplename"
                        Placeholder={props.t("Orders.Sheetorders.IDS_LBL_SAMPLE")}
                      />
                    </div>
                  )
                }

                <div className="form-group">
                  <label className="mg-r-1 form-label">
                    <span className={isMultitenant === 2 ? "label-top" : "label-top required"}>
                      {props.t("Orders.Sheetorders.IDS_LBL_KEYWORD")}
                    </span>
                  </label>
                  <Suspense fallback={<div></div>}>
                    <TextBox
                      txtType="text"
                      txtClsname={"form-control "}
                      txtName="keyword"
                      txtPlaceholder={props.t("Dashboard.IDS_LBL_ENTERKEYWORD")}
                      txtDataType="Text"
                      txtmaxlength="100"
                      txtrequired="true"
                      //autofocus="true"
                      txtvalue={selectOrderKey}
                      sendData={onOrderKeywordEnter}
                    />
                  </Suspense>
                </div>

                {isMultitenant === 2 && sessionStorage?.accouttype !== undefined && sessionStorage?.accouttype === "1" ? "" :
                  <div className="form-group">
                    <label htmlFor="inputPassword" className="form-label">
                      <span className="label-top ">
                        {props.t("Orders.Sheetorders.IDS_LBL_ASSIGNTO")}{" "}
                      </span>
                    </label>

                    <KendoCombobox
                      initialValue=""
                      id="id-combo-assignuser"
                      Datasource={flows}
                      DefaultValue={selectWflowData}
                      onvaluechange={handleWflowChange}
                      ValueMember="usercode"
                      DisplayMember="username"
                      Placeholder={props.t(
                        "Orders.Sheetorders.IDS_LBL_ORDERWORKFLOW", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER") }
                      )}
                    />
                  </div>
                }

                <div className="form-group">
                  <label className="mg-r-1 form-label">
                    <span className="label-top">
                      {props.t("Orders.Sheetorders.IDS_LBL_TITLE")}
                    </span>
                  </label>
                  <Suspense fallback={<div></div>}>
                    <TextBox
                      txtType="text"
                      txtClsname={"form-control "}
                      txtName="Title"
                      txtPlaceholder={props.t("ActiveWidgets.IDS_AWL_PLEASEENTERTHETITLE")}
                      txtDataType="Text"
                      txtmaxlength="100"
                      txtrequired="true"
                      //autofocus="true"
                      txtvalue={selectOrdertittle}
                      sendData={onOrdertittleEnter}
                    />
                  </Suspense>
                </div>

                {/* {isshowtosite === 3 ? (
                <div className="form-group">
                  <label htmlFor="inputPassword" className="form-label required">
                    <span className="label-top">{props.t("Orders.Sheetorders.IDS_LBL_SELECTPROJECT")}</span>
                  </label>

                  <KendoCombobox
                    initialValue=""
                    Datasource={userteamitems}
                    DefaultValue={selectuserteam}
                    onvaluechange={handleprojectteamChange}
                    ValueMember="teamcode"
                    DisplayMember="teamname"
                    Placeholder={props.t("Orders.Sheetorders.IDS_LBL_SELECTPROJECT")}
                  />
                </div>
              ) : false} */}
                {selectWflowData !== undefined &&
                  selectWflowData !== null &&
                  selectWflowData.usercode === -2 && (
                    <div className="form-group">
                      <label htmlFor="inputPassword" className="form-label">
                        user
                      </label>

                      <KendoCombobox
                        initialValue=""
                        id="id-combo-user"
                        Datasource={users}
                        DefaultValue={selectUser}
                        onvaluechange={handleuserChange}
                        ValueMember="usercode"
                        DisplayMember="username"
                        Placeholder={props.t("Orders.Sheetorders.IDS_LBL_USER")}
                      />
                    </div>
                  )}

                {isMultitenant === 2 ? false :
                  controlRights.dueDate ?
                    <div className="duedate form-group" style={{ marginTop: 14 }}>
                      <label className="clsCheckcontainer">
                        <input
                          type="checkbox"
                          onChange={handleDueDateCheck}
                          checked={isDueDateChecked}
                          disabled={isAutoRegister === true}

                        />
                        {props.t("Orders.Sheetorders.IDS_LBL_SETDUEDATE")}
                        <span className="checkmark"></span>
                      </label>
                    </div> : false
                }
                {isDueDateChecked ? (
                  <>
                    <div className="flex-form-group form-group padding-align-form disable-callendar-input">
                      <label className="DueDate DateandTime" htmlFor="inputText">
                        {props.t("Orders.Sheetorders.IDS_LBL_ORDERDUEDATE")}
                      </label>
                      {/* className="required"  */}
                      <Suspense fallback={<div></div>}>
                        <DatePicker
                          value={duedate}
                          onChange={(e: any) => onDatachange(e)}
                          max={maxDate}
                          min={minDate}
                          onFocus={handleTimePickerVisibility}
                          format={"dd/MM/yyyy"}
                        />
                        {showTimePicker ? (
                          <TimePicker
                            //value={duedate}
                            value={currentday}
                            //onChange={(event) => setduedate(event.target.value)}
                            onChange={timechange}
                            format="hh:mm:ss a" // 'a' for AM/PM

                            min={new Date(0, 0, 0, currentHour, currentMinute, currentSecond)}
                            max={new Date(0, 0, 0, 23, 59, 59)}
                          />
                        ) :
                          <TimePicker
                            //value={duedate}
                            value={currentday}
                            //onChange={(event) => setduedate(event.target.value)}
                            onChange={timechange}
                            format="hh:mm:ss a" // 'a' for AM/PM

                            min={new Date(0, 0, 0, 0, 0, 0)}
                            max={new Date(0, 0, 0, 23, 59, 59)}
                          />
                        }

                      </Suspense>
                    </div>
                    <div className="form-group-duedate form-group">
                      <label className="mg-r-1 form-label" style={{ display: 'block' }}>
                        <span className="label-top required">
                          {props.t("Orders.Sheetorders.IDS_LBL_SPELLBEFORE")}
                        </span>
                      </label>
                      <Suspense fallback={<div></div>}>
                        <TextBox
                          txtType="text"
                          txtClsname={"form-control "}
                          txtName="keyword"
                          txtPlaceholder={props.t("Number")}
                          txtDataType="Number"
                          txtmaxlength="3"
                          txtrequired="true"
                          inputmode="numeric"
                          pattern="^\d+$"
                          txtvalue={SpellBefore}
                          sendData={onSpellDayEnter}
                        />
                      </Suspense>
                      <KendoCombobox
                        initialValue=""
                        id="id-combo-MatCat"
                        Datasource={periods}
                        DefaultValue={periodsvalue}
                        onvaluechange={onHandleOpenExpPeriodChange}
                        ValueMember="type"
                        DisplayMember="name"
                        Placeholder={props.t("Orders.Sheetorders.IDS_LBL_PERIOD")}
                      />
                    </div>
                    {/* <div className="form-group">
                    <label className="required align-to-filter-label">{props.t("Orders.Sheetorders.IDS_LBL_PERIOD")}</label>
                        <KendoCombobox
                          initialValue=""
                          id="id-combo-MatCat"
                          Datasource={periods}
                          DefaultValue={periodsvalue}
                          onvaluechange={onHandleOpenExpPeriodChange}
                          ValueMember="type"
                          DisplayMember="name"
                        //  Placeholder={}
                        />
                </div> */}

                  </>
                ) : false}

                {/* for order auto registration */}
                {isMultitenant === 2 ? false :
                  controlRights.auotoReg ?
                    <div className="autoregister" style={{ marginTop: 24 }}>
                      <label className="clsCheckcontainer">
                        <input
                          type="checkbox"
                          onChange={handleAutoRegisterCheck}
                          checked={isAutoRegister === true}
                          disabled={isDueDateChecked}
                        />
                        {props.t("Orders.Sheetorders.IDS_LBL_AUTOREGISTER")}
                        <span className="checkmark"></span>
                      </label>
                    </div> : false
                }
                {isAutoRegister ? <>

                  <div className="form-group-duedate form-group">
                    <label className="mg-r-1 form-label" style={{ display: "block" }}>
                      <span className="label-top required">
                        {props.t("Orders.Sheetorders.IDS_LBL_INTERVAL")}
                      </span>
                    </label>
                    <Suspense fallback={<div></div>}>
                      <input
                        type="number"
                        className={"form-control"}
                        name="platecolumn"
                        placeholder={props.t("Parser.Instrument.IDS_LBL_NUMBER")}
                        datatype="int"
                        onChange={(event: any) => {
                          const Values = event.target.value;
                          if (/^\d*$/.test(Values) && Values !== "" && Values !== "0") {
                            onInterval(Values)
                          }
                          else {
                            props.props.alert.error(props.t("Common.IDS_MSG_VALIDINPUT"));
                            setInterval([])
                          }
                        }}
                        // max="100"
                        min="0"
                        value={Interval}
                      />
                      {/* <TextBox
                        txtType="text"
                        txtClsname={"form-control "}
                        txtName="keyword"
                        txtPlaceholder={props.t("Orders.Sheetorders.IDS_LBL_NUMBER")}
                        txtDataType="Number"
                        txtmaxlength="3"
                        txtrequired="true"
                        txtvalue={Interval}
                        sendData={onInterval}
                      /> */}
                    </Suspense>
                    <KendoCombobox
                      initialValue=""
                      id="id-combo-MatCat"
                      Datasource={Duration}
                      DefaultValue={Durationvalue}
                      onvaluechange={onHandleDurationValueChange}
                      ValueMember="type"
                      DisplayMember="name"
                      Placeholder={props.t("Orders.Sheetorders.IDS_LBL_DURATION")}
                    />
                  </div>
                  <div className="autoregister-count form-group" style={{ marginTop: 24 }}>
                    <Row>
                      <label className="mg-r-1 form-label" style={{ display: "block" }}>
                        <span className="label-top required">
                          {props.t("Orders.Sheetorders.IDS_LBL_AUTOREGISTERCOUNT")}
                        </span>
                      </label>
                      {/* <TextBox
                        txtType="number"
                        txtClsname={"form-control-autoregistercount form-control"}
                        txtName="platecolumn"
                        txtPlaceholder={props.t("Orders.Sheetorders.IDS_LBL_AUTOREGISTERCOUNT")}
                        txtDataType="Text"
                        txtmaxlength="3"
                        max="100"
                        min="0"
                        txtrequired="true"
                        txtvalue={Autoregister_Count}
                        sendData={(event: any) => {
                          // if (/^\d*$/.test(Values) && Number(Values) <= 100) {
                          //   setAutoregister_Count(Number(Values))
                          // }

                          const value = event.target.value;
                          if (value === "" || (Number(value) <= 100 && Number(value) >= 0)) {
                            setAutoregister_Count(Number(value))
                          }
                        }}
                      /> */}
                      <input
                        type="number"
                        className={"form-control-autoregistercount form-control"}
                        name="platecolumn"
                        placeholder={props.t("Orders.Sheetorders.IDS_LBL_AUTOREGISTERCOUNT")}
                        datatype="int"
                        onChange={(event: any) => {
                          const Values = event.target.value;
                          if (/^\d*$/.test(Values) && Number(Values) <= 100 && Values !== "") {
                            setAutoregister_Count(Number(Values))
                          } else {
                            setAutoregister_Count("")
                          }
                        }}
                        max="100"
                        min="0"
                        value={Autoregister_Count}
                      />
                    </Row>




                  </div>
                  {/* <div className="form-group">
               <label className="required align-to-filter-label">{props.t("Orders.Sheetorders.IDS_LBL_DURATION")}</label>
                   <KendoCombobox
                     initialValue=""
                     id="id-combo-MatCat"
                     Datasource={Duration}
                     DefaultValue={Durationvalue}
                     onvaluechange={onHandleDurationValueChange}
                     ValueMember="type"
                     DisplayMember="name"
                   //  Placeholder={}
               />
              </div> */}
                </>
                  : ""}




                {/* {selectOrderData !== undefined &&
                selectOrderData !== null &&
                selectOrderData.type !== 5 && (
                  isPremiumTenant || isMultitenant === 0 ?
                    <div className="form-group">
                      <label htmlFor="inputPassword" className="form-label" >
                        {props.t("Dashboard.IDS_LBL_CHOOSEMATERIALINVENTORY")}
                      </label>
                      <Suspense fallback={<div></div>}>
                        <KendoCombobox
                          initialValue=""
                          id="id-combo-materialinventory"
                          Datasource={stateMaterialInventory}
                          DefaultValue={selectMaterialInventory}
                          onvaluechange={onMaterialInventoryChange}
                          ValueMember="nmaterialinventorycode"
                          DisplayMember="sinventoryid"
                          Placeholder={props.t("Orders.Sheetorders.IDS_LBL_INVENTORY")}
                        />
                      </Suspense>
                    </div> :
                    <div className="form-group">
                      <label htmlFor="inputPassword" className="form-label">
                        {props.t("Orders.Sheetorders.IDS_LBL_RESOURCE")}
                      </label>
                      <KendoCombobox
                        initialValue=""
                        id="id-combo-repodata"
                        Datasource={stateRepodataData}
                        DefaultValue={selectRepodataData}
                        onvaluechange={handleRepodataChange}
                        ValueMember="repositorydatacode"
                        DisplayMember="repositoryitemname"
                        Placeholder={props.t("Orders.Sheetorders.IDS_LBL_RESOURCE")}
                      />
                    </div>
                )} */}
              </div>
            </div>
          </div>

          {isMultitenant === 2 ? false : (selectProjectData === undefined || selectProjectData === null) && (
            <fieldset className="pb-0">
              <legend className="dash-legend">
                {isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASKVISBLEITY") : props.t("Dashboard.IDS_LBL_ORDERVISIBILITY")}
              </legend>
              <div className="row clearfix">
                {/* <span className="m-2 d-inline-block pl-2">{props.t("Dashboard.IDS_LBL_ORDERVISIBILITY")}</span> */}
                <div className="equal-split-flex w-100 parent-padd-1 pb-0">
                  <div className="form-group">
                    <label className={"radio"}>
                      <input
                        type="radio"
                        value="1"
                        name="Selectordershow"
                        onChange={onshowtosite}
                        checked={isshowtosite === 1}
                      />
                      <span>
                        {props.t("Orders.Sheetorders.IDS_LBL_SHOWTOTHESITE")}
                      </span>
                    </label>
                  </div>
                  {/* <div className="form-group">
                    <label className={"radio"}>
                      <input
                        type="radio"
                        value="2"
                        name="Selectordershow"
                        onChange={onshowonlytome}
                        checked={isshowtosite === 2}
                      />
                      <span>
                        {props.t("Orders.Sheetorders.IDS_LBL_SHOWONLYTOME")}
                      </span>
                    </label>
                  </div> */}

                  {controlRights.projectteam ?
                    <div className="form-group">
                      <label className={"radio"}>
                        <input
                          type="radio"
                          value="3"
                          name="Selectordershow"
                          onChange={onshowonlytome}
                          checked={isshowtosite === 3}
                        />
                        <span>
                          {props.t("Orders.Sheetorders.IDS_LBL_SHOWONLYTOTEAM")}
                        </span>
                      </label>
                    </div>
                    : ""}

                  {/* {isshowtosite === 3 ?
                    <ProjectTeam
                      isshowtosite={isshowtosite}
                      t={props.t}
                      props={props.props}
                      screen={props.screen}
                      rights={props.userrightdetails}
                      onprojectteamchange={onprojectteamchange}
                      
                    ></ProjectTeam>
                    :""
                  } */}

                </div>
              </div>
              {isshowtosite === 3 ?
                <ProjectTeam
                  isshowtosite={isshowtosite}
                  t={props.t}
                  props={props.props}
                  screen={props.screen}
                  rights={props.userrightdetails}
                  onprojectteamchange={onprojectteamchange}

                ></ProjectTeam>
                : ""
              }
            </fieldset>
          )}

          <span className="mt-2 d-inline-block">
            {props.t("Orders.Sheetorders.IDS_LBL_SAVEWITHIN")}
          </span>

          <div className="row clearfix">
            {/* <div className="col-6 mg-t-1">
            <div className="form-group form-label-half">
              <label className={"radio"}>
                <input
                  type="radio"
                  value="1"
                  name="Selectfolder"
                  onChange={onsaveonproject}
                  checked={isMoveParent === 1}
                  disabled={
                    selectProjectData !== undefined &&
                    selectProjectData !== null
                      ? false
                      : true
                  }
                />
                <span>
                  {props.t("Orders.Sheetorders.IDS_LBL_SAVEONPROJECT")}
                </span>
              </label>
              {selectOrderData !== undefined &&
              selectOrderData !== null &&
              selectOrderData.type !== 5 ? (
                <label className={"radio"}>
                  <input
                    type="radio"
                    value="2"
                    name="Selectfolder"
                    onChange={onsaveonsample}
                    checked={isMoveParent === 2}
                    disabled={
                      selectMaterial !== undefined && selectMaterial !== null
                        ? false
                        : true
                    }
                  />
                  <span>{props.t("Logbook.IDS_LBL_MATERIAL")}</span>
                </label>
              ) : (
                <></>
              )}
              {isStoreOnCurrent && (
                <label className={"radio"}>
                  <input
                    type="radio"
                    value="3"
                    name="Selectfolder"
                    onChange={onexistingfolder}
                    checked={isMoveParent === 3}
                    disabled={
                      (selectMaterial !== undefined &&
                        selectMaterial !== null) ||
                      (selectProjectData !== undefined &&
                        selectProjectData !== null)
                        ? true
                        : false
                    }
                  />
                  <span>
                    {props.t("Orders.Sheetorders.IDS_MSG_ORDEREXISTS")}
                  </span>
                </label>
              )}
              <label className={"radio"}>
                <input
                  type="radio"
                  value="4"
                  name="Selectfolder"
                  onChange={onselectfolder}
                  checked={isMoveParent === 4}
                  disabled={
                    (selectMaterial !== undefined && selectMaterial !== null) ||
                    (selectProjectData !== undefined &&
                      selectProjectData !== null)
                      ? true
                      : false
                  }
                />

                <span>
                  {props.t("Orders.Sheetorders.IDS_LBL_CHOOSEFOLDER")}
                </span>
              </label>
            </div>
          </div> */}
            <div
              className={
                "d-block mg-t-1 k-filemanager-content-container  form-tree-view"
                // (isMoveParent === 4   ? "" : " clsdisablediv")
              }
            >
              <Suspense fallback={<div></div>}>
                <FolderTree
                  data={getFolderTree(stateData, selectedTreeItem)}
                  selected={selectedTreeItem}
                  selectedItem={selectedTreeItem}
                  onItemClick={handleTreeItemClick}
                  onContextMenu={handleContextMenuView}
                />
              </Suspense>
            </div>

          </div>
          <>
            <br />
            <div className="form-group " style={{ textAlign: "justify" }}>
              <b>{props.t("Orders.Sheetorders.IDS_LBL_FPATH")} : </b>
              {Selected_Path || ""}
            </div>

          </>
        </div>
        <DialogActionsBar>
          <div className="k-dialog-buttongroup d-flex">

            {controlRights.newFolder ?
              <Button
                className="btn btn-primary-blue m-2 mg-l-1 mg-r-half"
                onClick={() => {
                  setEnable_Newfolder(true); if (props.Onenablenewfolder !== undefined) { props.Onenablenewfolder(true) };
                  const element = document.getElementById('Order_Registration');
                  if (element) { element.style.position = 'relative'; element.style.zIndex = '99'; }
                }}
              >
                {" "}
                <i className="fa-solid fa fa-folder-plus" />
                <span>
                  {props.t("Orders.Sheetorders.IDS_LBL_NEWFOLDER", { param: "", })}
                </span>
              </Button> : false}

            {controlRights.register && <Button
              id="id-dialog-register"
              value={"create"}
              className="btn btn-user btn-primary-blue m-2"
              onClick={handleRegisterOrderClick}
            >
              {props.t("Orders.Protocolorders.IDS_LBL_REGISTERORDER", { screenname: isMultitenant === 2 ? props.t("Dashboard.IDS_LBL_TASK") : props.t("Dashboard.IDS_LBL_ORDER") })}
            </Button>}

            <Button
              id="id-dialog-close"
              value={"cancel create"}
              className="textBtn btn_white_bg button m-2"
              onClick={handleCreateDialogClose}
            >
              {props.t("Orders.Protocolorders.IDS_LBL_CANCEL")}
            </Button>
          </div>
        </DialogActionsBar>

      </DialogComponent>
      {Enable_Newfolder && props?.Addnewfolder_Onregister &&

        <Modal centered isOpen={true}>
          <ModalBody>
            <div className="login-form">
              <AddDialog
                addValue={undefined}
                onDialogClose={() => { setEnable_Newfolder(false); }}
                onDialogClick={props.onDialogClick}
                sessionvalues={props.sessionvalues}
                folderdata={props.folderdata}
                t={props.t}
                alert={props?.props.alert}
                selectedFolder={props.selectedFolder}
                props={props?.previousprops}
                Enable_Newfolder={Enable_Newfolder}
              />
            </div>
          </ModalBody>
        </Modal>
      }
    </div>

  );
};

export const DeleteDialog = (props: any) => {
  const stateData1 = removeDataItemandStaticFolder(
    props.folderdata,
    props.userData != null ? props.userData : { path: "-" }
  );
  const stateData = removeDataItemandStaticFolder(
    stateData1,
    props.selectedItem != null ? props.selectedItem : { path: "-" }
  );

  const [selectedTreeItem, setSelectedTreeItem] =
    React.useState<DataModel | null>(null);
  const [treeClicked, setTreeClicked] = React.useState<boolean>(false);
  const [isMoveParent, setIsMoveParent] = React.useState<number>(0);
  const [isMoveFolderStructure, setIsMoveFolderStructure] =
    React.useState<boolean>(true);
  const [directoryToMove, setDirectoryToMove] = React.useState<number>(-1);
  const multiselectfolders =
    props.selectedFolders?.length > 0
      ? props.selectedFolders.some((folder: any) => folder.items?.length > 0)
      : false;

  const onAuditValidateError = (response: any) => { };

  const onAuditValidateFailure = (response: any) => { };

  useLayoutEffect(() => {
    if (
      props.selectedItem !== undefined &&
      props.selectedItem.parentdircode !== undefined &&
      props.selectedItem.parentdircode === -1
    ) {
      // setIsMoveParent(1);
      setIsMoveParent(0);
      setDirectoryToMove(-1);
    } else if (
      props.selectedItem !== undefined &&
      props.selectedItem.parentdircode !== undefined
    ) {
      // setDirectoryToMove(props.selectedItem.parentdircode);
      //props.selectedItem.parentdircode !== -1 ? setDirectoryToMove(props.selectedItem.parentdircode) : setDirectoryToMove(-1);
      setDirectoryToMove(-1);
    }

    $(".dialogue-inner-panel .k-overlay").click((event) => {
      props.onDialogClose(event);
    });
  }, [props]);

  const handleDialogClick = (event: any) => {
    props.onDialogClick({
      event,
      type: event.target.value,
      directoryToMove: directoryToMove,
      directoryToDelete: props.selectedItem,
      keepfolderstructure: isMoveFolderStructure,
      dynamicfolders: stateData,
      movestatus: isMoveParent,
      selectedItem: props.selectedItem,
    });
  };

  const handleDialogClose = (event: any) => {
    props.onDialogClose(event);
    let passObjDet = {
      objsilentaudit: Silentauditobject(
        "close",
        "Sheet Orders",
        props.t("Orders.Sheetorders.IDS_REQCLOSEDELETE", {
          user: props.sessionvalues.username,
        })
      ),
    };
    Servicecalls(
      "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDet,
      onAuditValidateError.bind(this),
      onAuditValidateFailure.bind(this)
    );
  };

  const handleTreeItemClick = (event: TreeViewItemClickEvent) => {
    const newSelectedItem: DataModel = searchTreeItem(stateData, event.item);
    newSelectedItem.expanded = !event.item.expanded;

    setSelectedTreeItem(newSelectedItem);
    setTreeClicked(!treeClicked);
    if (
      newSelectedItem !== undefined &&
      newSelectedItem.directorycode !== undefined
    ) {
      setDirectoryToMove(newSelectedItem.directorycode);
    }
  };

  const handleContextMenuView = (event: ContextMenuEvent) => { };

  const handleMovetoChange = (event: any) => {
    setIsMoveParent(parseInt(event.target.value));
  };

  const handleMoveFolderChange = (event: any) => {
    console.log(isMoveFolderStructure);
    setIsMoveFolderStructure(!isMoveFolderStructure);
  };

  return (
    <DialogComponent
      className="dialogue-inner-panel confirm-popup"
      title={props.t("Orders.Protocolorders.IDS_LBL_CONFIRM")}
      onClose={handleDialogClose}
    >
      <p style={{ width: props.screen === 'protocolorder' || props.screen === 'sheetorder' ? "" : "350px", margin: "25px", textAlign: "center" }}>
        {props.t("Orders.Sheetorders.IDS_MSG_DELETESELECTFILE")}
      </p>
      {/* {props.selectedItem !== undefined &&
        props.selectedItem !== null &&
        props.selectedItem.items !== undefined &&
        props.selectedItem.items.length > 0 && */}

      {((props.selectedItem?.items?.length > 0 &&
        props.selectedFolders.length === 0) ||
        (multiselectfolders && props.selectedFolders.length > 0)) && (
          <div className="clsprocessselection card-inner">
            {/* { */}
            {/* props.selectedItem.parentdircode !== undefined &&
          props.selectedItem.parentdircode !== -1 &&
          stateData.length === 0? ( */}
            <label className="radio mb-2 clsdisplayblock ">
              <input
                type="radio"
                value="0"
                name="Selectfolder"
                onChange={handleMovetoChange}
                checked={isMoveParent === 0 ? true : false}
              />
              <span>{props.t("Orders.Sheetorders.IDS_LBL_MOVEORDERPARENT")}</span>
            </label>
            {/* ) : ( */}

            {/* props.selectedItem.parentdircode !== undefined &&
          props.selectedItem.parentdircode !== -1 &&
           <label className="radio mb-2 clsdisplayblock ">
            <input
              type="radio"
              value="0"
              name="Selectfolder"
              onChange={handleMovetoChange}
              checked={isMoveParent === 0 ? true : false}
            />
            <span>{props.t("Orders.Sheetorders.IDS_LBL_MOVEORDERPARENT")}</span>
          </label> */}

            {/* )}  */}
            {stateData.length !== 0 ? (
              <label className="radio mb-2 clsdisplayblock ">
                <input
                  type="radio"
                  value="1"
                  name="Selectfolder"
                  onChange={handleMovetoChange}
                  checked={isMoveParent === 1 ? true : false}
                />
                <span>
                  {props.t("Orders.Sheetorders.IDS_LBL_CHOOSEFOLDERTOMOVE")}
                </span>
              </label>
            ) : (
              ""
            )}
            <div className="mt-3">
              <label className="clsCheckcontainer">
                <input
                  type="checkbox"
                  onChange={handleMoveFolderChange}
                  checked={isMoveFolderStructure}
                />
                {props.t("Orders.Sheetorders.IDS_LBL_MOVEWITHFOLDER")}
                <span className="checkmark"></span>
              </label>
            </div>
          </div>
        )}
      {/* } */}

      {isMoveParent === 1 ? (
        <Suspense fallback={<div></div>}>
          <div className="folder-tree">
            <FolderTree
              data={getFolderTree(stateData, selectedTreeItem)}
              selected={selectedTreeItem}
              selectedItem={selectedTreeItem}
              onItemClick={handleTreeItemClick}
              onContextMenu={handleContextMenuView}
            />
          </div>
        </Suspense>
      ) : (
        ""
      )}
      <DialogActionsBar>
        <button
          id="id-dialog-delete"
          value={"delete"}
          className="k-button k-state-selected btn btn-primary-blue mr-2 my-2"
          onClick={handleDialogClick}
        >
          {props.t("Orders.Sheetorders.IDS_LBL_DELETE")}
        </button>
        <button
          id="id-dialog-canceldelete"
          value={"cancel delete"}
          className="k-button btn_white_bg mr-2 button"
          onClick={handleDialogClick}
        >
          {props.t("Orders.Sheetorders.IDS_LBL_CANCEL")}
        </button>
      </DialogActionsBar>
    </DialogComponent>
  );
};

export const MoveDialog = (props: any) => {
  // const stateData1 = removeDataItemnotcustomFolders(
  //   props.folderdata,
  //   props.userData != null ? props.userData : { path: "-" }
  // );
  // const stateData = props.isshowallfolder ? props.folderdata : removeDataItemnotcustomFolders(
  //   stateData1,
  //   props.selectedItem != null ? props.selectedItem : { path: "-" }
  // );
  let newItems: DataModel[] = [];
  const customefolder = collectcustomfolderfromstatic(
    props.folderdata,
    newItems
  );
  const [stateData] = React.useState<any>(
    props.isshowallfolder === 0
      ? props.folderdata
      : removeDataItemandStaticFolder(
        removeDataItemandStaticFolder(
          props.isshowallfolder === 1 ? customefolder : props.folderdata,
          props.userData != null ? props.userData : { path: "-" }
        ),
        props.selectedItem != null
          ? props.isshowallfolder === 1
            ? props.mutifolders
            : props.selectedItem
          : { path: "-" }
      )
  );
  const [selectedTreeItem, setSelectedTreeItem] =
    React.useState<DataModel | null>(null);
  const [treeClicked, setTreeClicked] = React.useState<boolean>(false);

  //const onAuditValidateError = (response: any) => { };

  //const onAuditValidateFailure = (response: any) => { };

  useLayoutEffect(() => {
    // const newSelectedItem: DataModel = searchTreeItem(stateData, props.selectedFolder);
    // // newSelectedItem.expanded = true;
    // setSelectedTreeItem(newSelectedItem);

    // let passObjDet = {
    //   objsilentaudit: Silentauditobject(
    //     "view",
    //     "Register Orders",
    //     props.t("FOLDER.IDS_REQMOVEFOLDER", {
    //       user: props.sessionvalues.username,
    //     })
    //   ),
    // };

    // Servicecalls(
    //   "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
    //   passObjDet,
    //   onAuditValidateError.bind(this),
    //   onAuditValidateFailure.bind(this)
    // );
    $(".dialogue-inner-panel .k-overlay").click((event) => {
      props.onDialogClose(event);
    });
  }, [props, stateData]);

  const handleDialogClick = (event: any) => {
    props.SelectAllFile || props.isSelectAllFile
      ? props.onDialogClick({
        event,
        type: event.target.value,
        selectedfolder: selectedTreeItem,
        selecteditem: props.selectedFolder === undefined ? props.selectedItem : props.selectedFolder.items[0],
      })
      : props.SelectAllOrder || props.isSelectAllOrder
        ? props.onDialogClick({
          event,
          type: event.target.value,
          selectedfolder: selectedTreeItem,
          selecteditem: props.selectedFolder === undefined ? props.selectedItem : props.selectedFolder.items[0],
        })
        : props.onDialogClick({
          event,
          type: event.target.value,
          selectedfolder: selectedTreeItem,
          selecteditem: props.selectedItem,
        });
  };

  const handleDialogClose = (event: any) => {
    props.onDialogClose(event);
    // let passObjDet = {
    //   objsilentaudit: Silentauditobject(
    //     "close",
    //     "Register Orders",
    //     props.t("FOLDER.IDS_REQCLOSEMOVE", {
    //       user: props.sessionvalues.username,
    //     })
    //   ),
    // };
    // Servicecalls(
    //   "" + ELNurl + "/AuditTrail/silentandmanualRecordHandler",
    //   passObjDet,
    //   onAuditValidateError.bind(this),
    //   onAuditValidateFailure.bind(this)
    // );
  };

  const handleTreeItemClick = (event: TreeViewItemClickEvent) => {
    const newSelectedItem: DataModel = searchTreeItem(stateData, event.item);
    newSelectedItem.expanded = !event.item.expanded;
    if (
      props.selectedItem?.viewoption === 1 &&
      (newSelectedItem?.viewoption === 2 || newSelectedItem?.viewoption === 3)
    ) {
      props.alert.error(
        props.t("Orders.Sheetorders.IDS_CONNOTOMVE", { showitem: "to team" })
      );
    } else if (
      props.selectedItem?.viewoption === 1 &&
      newSelectedItem?.viewoption === 3
    ) {
      props.alert.error(
        props.t("Orders.Sheetorders.IDS_CONNOTOMVE", { showitem: "to team" })
      );
    } else {
      setSelectedTreeItem(newSelectedItem);
      setTreeClicked(!treeClicked);
    }
  };

  const handleContextMenuView = (event: ContextMenuEvent) => { };

  return (
    <>
      <Modal isOpen={true} toggle={handleDialogClose}>
        <div className="modal-header">
          <h5 className="modal-title">
            {props.t("Orders.Sheetorders.IDS_LBL_CONFIRM")}
          </h5>
        </div>
        <ModalBody className={`k-filemanager-content-container ${props.screen === 'sheetorder' || props.screen === 'protocolorder' ? 'movepopup' : ''}`}>
          <Suspense fallback={<div></div>}>
            <FolderTree
              data={getFolderTree(stateData, selectedTreeItem)}
              selected={selectedTreeItem}
              selectedItem={selectedTreeItem}
              onItemClick={handleTreeItemClick}
              onContextMenu={handleContextMenuView}
            />
          </Suspense>
        </ModalBody>
        <div className="modal-footer  content-end no-nav-footer">
          <button
            id="id-dialog-move"
            type="button"
            className="btn btn-user btn-primary-blue"
            onClick={handleDialogClick}
          >
            {props.t("Orders.Sheetorders.IDS_LBL_MOVE")}
          </button>
          <button
            id="id-dialog-canceldelete"
            type="button"
            className="btn modalbluebtn button"
            onClick={handleDialogClose}
          >
            {"close"}
          </button>
        </div>
      </Modal>
    </>
  );
};

export const CommonDialog = (props: any) => {
  const [savebuttondisabled, setSavebuttondisabled] = useState(false);
  return (
    <>
      <Modal centered isOpen={true}>
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            {props.t(props.header !== undefined ? props.header : "")}
          </h5>
          <button
            id="id-dialog-closemodel"
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            // onClick={props.closeModel() !== undefined ? props.closeModel() : closefunction}
            onClick={() => props.closeModel()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <ModalBody>
          <div className="login-form">
            {/* <p>{props.t(props.bodycontent !== undefined ? props.bodycontent : "")}</p> */}
            <p>{props.bodycontent !== undefined ? props.bodycontent : ""}</p>
          </div>
        </ModalBody>
        <div id="UserMasterADD-modal-footer" className="modal-footer">
          <button
            type="button"
            id="id-dialog-savemodel"
            className="btn btn-user btn-primary-blue"
            // onClick={() => props.onsavecancelformodal()}
            onClick={() => {
              setSavebuttondisabled(true);
              props.onsavecancelformodal(props?.saveActiontype)
            }}
            disabled={savebuttondisabled}
          >
            {props.submitbuttonname !== undefined ? props.submitbuttonname : ""}
            {/* {props.t("Templates.Protocoltemplates.IDS_LBL_SUBMIT")} */}
          </button>
          {props.ButtonCount !== undefined &&
            <button
              type="button"
              id="id-dialog-savemodel"
              className="btn btn-user btn-primary-blue"
              onClick={() => props.onDiscardformodal()}
            >
              {props.Discardbuttonname !== undefined ? props.Discardbuttonname : ""}
            </button>
          }


          <button
            type="button"
            className="btn modalbluebtn button"
            data-dismiss="modal"
            id="id-dialog-closemodel"
            onClick={() => props.closeModel()}
          >
            {props.closeuttonname !== undefined ? props.closeuttonname : ""}
            {/* {props.t("Templates.Protocoltemplates.IDS_LBL_CLOSE", { param: "" })} */}
          </button>
        </div>
      </Modal>
    </>
  );
};
